import React, { useState, useEffect, useRef, useMemo } from "react";
import { debounce } from "lodash";
import AceEditor from "react-ace";
import {
  createSetLoading,
  extractDollarPrefixedColumns,
  useToast,
} from "../../services/utils";
import { useNavigate, useLocation } from "react-router-dom";
import ReactDOM from "react-dom";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Input,
  IconButton,
  Button,
  Grid,
  TextField,
  Autocomplete,
  TextareaAutosize,
  Tooltip,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemText,
  NativeSelect,
  Checkbox,
} from "@mui/material";
import SystemTypeAutocomplete from "../../components/common/SystemTypeAutocomplete";
import LinkIcon from "@mui/icons-material/Link";
import { CheckCircleRounded } from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid";
import * as Yup from "yup";
import { toast } from "react-toastify";
import DataTable from "../../components/DataGrids/DataGrid";
import {
  aggregationType,
  datatypes,
  dateTimeFormat,
  severity_level,
  sqlDatabaseType,
  contentType,
  methodType,
  apiType,
  validationScoringConfigDefaults,
} from "../../services/constants";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IDomainsData } from "../../types/domain";
// import useFetchDomains from "../../hooks/useFetchDomains";
import {
  updateResource,
  updateResourceColumn,
  detectSensitiveColumns as detectSensitiveColumnsService,
} from "../../services/resourcesService";
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from "@mui/x-data-grid-pro";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ViewJsonSplitButton from "../../components/common/ViewJsonSplitButton";
import {
  defaultEditResourceCDMColumns,
  editResourceCDMColumns,
} from "../../services/constants/resource";
import ValidationDialog from "../../components/Dialogs/ValidationDialog";
import DerivedColumnDialog from "../../components/Dialogs/DerivedColumnDialog";
import ReferenceDialog from "../../components/Dialogs/ReferenceDialog";
import CustomValidationSummary from "./CustomValidationSummary";
import {
  addEditResourceSchema,
  validationScoringConfigFormSchema,
  filterRulesNameSchema,
  filterRulesSqlSchema,
  aggregatedValidateSchema,
  basicAuthApiSchema,
  tokenAuthApiSchema,
  keyAuthApiSchema,
  oAuthApiSchema,
  noAuthApiSchema,
  localDefinitionSchema,
  blobDefinitionSchema,
  sftpDefinitionSchema,
  sqlDefinitionSchema,
  addNewResourceNewDomainWithoutLinkedServiceSchema,
} from "../../schemas";
import { isSchemaValidSync } from "../../utils/scoringConfigFormValidation";
import AggregatedResource from "../../components/Resource/AggregatedResource";
import {
  extractColumnNamesFromQuery,
  manageAvailableColumns,
  isResourceColumnNameValid,
  setDataType,
} from "../../services/utils";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { formattedJson } from "../../services/utils";
import FilterRules from "../../components/Resource/FilterRules";
import { useResourceContext } from "../../contexts/ResourceContext";
import AdditionalResource from "../../components/Resource/AdditionalResource";
import {
  buildAdditionalResourceColumnInfo,
  mergeResourceColumnsWithMetadata,
} from "../../services/utils/mergeResourceColumns";
import ConfirmDailog from "../../components/Dialogs/ConfirmDailog";
import CheckboxWithKeyboardEvent from "../../components/Molecules/Resource/CheckboxWithKeyboardEvent";
import { useRuleResourceContext } from "../../contexts/RuleResourceContext";
// import RenderVariables from "../../components/Molecules/Resource/RenderVariables";
import AddMultiGrid from "../../components/AddMultiGrid";
import CrossFieldValidations from "../ResourceColumns/CrossFieldValidations";
// import AvailableVariables from "../../components/Molecules/Variables/AvailableVariables";
import SqlQueryDialog from "../../components/Dialogs/SqlQueryDialog";
import Loader from "../../components/Molecules/Loader/Loader";
import CommentBeforeUpdateDialog from "../../components/Dialogs/CommentBeforeUpdateDialog";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import CustomAccordion from "../../components/Molecules/Accordian/CustomAccordion";
import ViewVariables from "../../components/Molecules/Resource/ViewVariables";
import useFetchLinkedServices from "../../hooks/useFetchLinkedServices";
import useFetchFileProcessing from "../../hooks/useFetchFileProcessing";
import useFetchResourceColumnsByDomain from "../../hooks/useFetchResourceColumnsByDomain";
import useFetchResourceById from "../../hooks/useFetchResourceById";
import useFetchDomains from "../../hooks/useFetchDomains";
import useFetchConnectionKeysAll from "../../hooks/useFetchConnectionKeysAll";
import ResourceColumnNameCell from "../../components/Molecules/Resource/ResourceColumnNameCell";
import ResourceDataFormatCell from "../../components/Molecules/Resource/ResourceDataFormatCell";
import {
  IconAddRowBase,
  IconDeleteBlueSvg,
  IconEditBase,
  IconEyeBase,
  IconPlusBase,
} from "../../common/utils/icons";
import { useSystemContext } from "../../contexts/TagAndSystemProvider";
import useFetchAllSystem from "../../hooks/useFetchAllSystem";
import { EditAuthTags } from "../../components/AuthTags";
import useFetchConnectionKeyByFilter from "../../hooks/useFetchConnectionKeyByFilters";
import { useAuth } from "../../contexts/AuthContext";
import useFetchAllAuthTagsList from "../../hooks/useFetchAllAuthTagsList";
import { useAuthTagContext } from "../../contexts/TagAndSystemProvider";
import ValidationScoringConfigForm from "../../components/Scoring/ValidationScoringConfigForm";
import useFetchValidationScoringConfig from "../../hooks/useFetchValidationScoringConfig";
import {
  createValidationScoringConfig,
  updateValidationScoringConfig,
} from "../../services/scoringService";
import { getAllConnectionKeys } from "../../services/connectionKeysService";
import { useRowsPerPage } from "../../hooks/useRowsPerPage";
import ViewPayloadDialog from "../../components/Dialogs/ViewPayloadDialog";
import { validateConfigRequest } from "../../services/resourcesService";

const ACCORDION_HEADER: any = {
  resourceData: "Resource Details",
  linkedService: "Connection Details",
  additionalData: "Additional Data",
  filterRules: "Filter Rules",
};

const EditResource: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const {
    formData,
    setFormData,
    setResourceId,
    errors,
    setErrors,
    isLoading,
    setIsLoading,
    linkedServicesData,
    setLinkedServicesData,
    fileProcessingData,
    setFileProcessingData,
    connectionKeysData,
    setConnectionKeysData,
    resourceColumns,
    setResourceColumns,
    currentDomainId,
    setCurrentDomainId,
    resourceData,
    setResourceData,
    resourceColumnDataObj,
    setResourceColumnDataObj,
    resourceColumnData,
    setResourceColumnData,
    currentResourceColumnId,
    setCurrentResourceColumnId,
    editResourceId,
    currentResourceId,
    setCurrentResourceId,
    setOpenValidationDialog,
    // selectedRowId,
    setSelectedRowId,
    setIsDailogEdit,
    fileData,
    setFileData,
    setDailogEditIndex,
    setOpenDerivedColumnDialog,
    setDerivedModalType,
    setOpenReferenceDialog,
    setReferenceData,
    baseResourceColumns,
    setBaseResourceColumns,
    domainsData,
    setDomainsData,
    fetchedConnectionKeys,
    setFetchedConnectionKeys,
    refetchData,
    fetchKey,
    allResourcesAdditionalData,
    resourceColumns: resourceColumnsFromContext,
  } = useResourceContext();

  const {
    availColumns,
    setAvailColumns,
    setAvailColumnsWithResourceDetail,
    globalVariables,
    setGlobalVariables,
    type,
    setType,
    setQueryBuilderTempValue,
    queryBuilderTempValue,
    tempGlobalVariables,
    setTempGlobalVariables,
  } = useRuleResourceContext();

  const { hasPermission, isAdmin } = useAuth();

  const canValidateResource = hasPermission("resource", "validate");
  const canEditResource = hasPermission("resource", "edit");
  const canDetectSensitiveColumns = hasPermission(
    "resource_column_details",
    "edit",
  );
  const [isDetectingColumns, setIsDetectingColumns] = useState(false);

  const defaultPage = process.env.REACT_APP_DEFAULT_PAGE;
  const [page, setPage] = useState<number>(
    defaultPage ? parseInt(defaultPage) : 1,
  );

  const { rowsPerPage } = useRowsPerPage();
  const [pSize, setPSize] = useState<number>(rowsPerPage);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [selectedDomain, setSelectedDomain] = useState<IDomainsData>();
  const { showToast } = useToast();
  const [expandedRow, setExpandedRow] = useState<any>([]);
  // const [selectLinkedServiceId, setSelectLinkedServiceId] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<string>("resourceColumns");
  const [expandedAccordion, setExpandedAccordion] =
    useState<any>("resourceData");
  const [crossFieldValidations, setCrossFieldValidations] = useState<any>([]);
  const formEventRef = useRef<any>(null);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [resourceColumnObj, setResourceColumnObj] = useState<any>(null);
  const [isDailogOpen, setIsDailogOpen] = useState(false);
  const [allVariablesList, setAllVariablesList] = useState<any>({});
  const [oldColumnName, setOldColumnName] = useState("");
  const [queryParams, setQueryParams] = useState([]);
  const [urlParams, setUrlParams] = useState([]);
  const [showQryModal, setShowQryModal] = useState<any>(false);
  const [isPayloadDialogOpen, setIsPayloadDialogOpen] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [validationResponse, setValidationResponse] = useState<any>(null);
  const [scoringConfigValues, setScoringConfigValues] = useState<any>(null);
  const [isScoringConfigValid, setIsScoringConfigValid] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [openCommentConfirmation, setOpenCommentConfirmation] =
    useState<boolean>(false);

  // System ID validation modal state
  const [showSystemIdMismatchModal, setShowSystemIdMismatchModal] =
    useState<boolean>(false);
  const [systemIdMismatchData, setSystemIdMismatchData] = useState<{
    resourceSystemId: number | null;
    connectionKeySystemId: number | null;
    connectionKeyName: string;
    fieldType: "file" | "sql" | "postgres_sql" | "api";
    isPageLoad?: boolean;
  } | null>(null);
  const [initialFormData, setInitialFormData] = useState<any>({});
  const [initialFileData, setInitialFileData] = useState<any[]>([]);
  const [initialCrossFieldValidations, setInitialCrossFieldValidations] =
    useState<any[]>([]);
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [loadingStates, setLoadingStates] = useState({
    linkedService: false,
    fileProcessing: false,
    connectionKey: false,
    resourceColumns: false,
    resource: false,
    domains: false,
    allConnectionKey: false,
    systems: false,
  });
  const setLoading = createSetLoading(setLoadingStates);
  const [linkedServices] = useFetchLinkedServices({
    setIsLoading: setLoading("linkedService"),
  });
  const [fileProcessing] = useFetchFileProcessing({
    setIsLoading: setLoading("fileProcessing"),
  });
  const [connectionKeys] = useFetchConnectionKeyByFilter({
    filterKeys: (formData as any)?.linked_service?.connection_details
      ?.connection_keys,
    system_id: formData?.system_id,
    setIsLoading: setLoading("connectionKey"),
  });
  const [resourceColumnsData] = useFetchResourceColumnsByDomain({
    currentDomainId,
    setIsLoading: setLoading("resourceColumns"),
  });

  let [resource, resourceColumnDataObjData] = useFetchResourceById({
    currentResourceId,
    currentResourceColumnId,
    setIsLoading: setLoading("resource"),
    fetchKey,
  });
  const [domains] = useFetchDomains({ setIsLoading: setLoading("domains") });

  // Get the setter function from context (following linkedServicesData pattern)
  const { allSystemData, setAllSystemData } = useSystemContext();

  // Fetch system data directly in this component (following linkedServicesData pattern)
  const [systemData] = useFetchAllSystem({
    setIsLoading,
  });

  const [allConnectionKeys] = useFetchConnectionKeysAll({
    setIsLoading: setLoading("allConnectionKey"),
    shouldFetch: true, // Explicitly enable for this component
  });

  // Get the setter function from context (following linkedServicesData pattern)
  const { setAllAuthTagsData } = useAuthTagContext();

  // Fetch auth tags data directly in this component (following linkedServicesData pattern)
  const [authTagsData] = useFetchAllAuthTagsList({
    setIsLoading,
  });
  const [validationScoringConfig] = useFetchValidationScoringConfig({
    setIsLoading,
    resourceId: currentResourceId,
  });
  const effectiveScoringConfigValues =
    scoringConfigValues ??
    validationScoringConfig ??
    validationScoringConfigDefaults;
  const canSaveScoringConfig =
    isScoringConfigValid &&
    isSchemaValidSync(
      validationScoringConfigFormSchema,
      effectiveScoringConfigValues,
    );

  // const editorRef = useRef<AceEditor | null>(null);

  // const extractVariables = (query: any) => {
  //   const matches = query?.match(/\$\$(.*?)\$\$/g);
  //   if (!matches) return [];
  //   return matches.map((match: any) => match.slice(2, -2).toLowerCase());
  // };
  // const getUniqueValues = (arr: any) => {
  //   return arr.filter((v: any, i: any, a: any) => a.indexOf(v) === i);
  // };
  // useEffect(() => {
  //   const queryVariables: any = extractVariables(
  //     formData?.resource_definition?.sql_query
  //   );
  //   const variables = getUniqueValues([...queryVariables]);
  //   if (
  //     variables?.length > 0 &&
  //     globalVariables &&
  //     formData?.aggregation_type === "flat"
  //   ) {
  //     const globalVars: any = {};
  //     variables.forEach((variable: any) => {
  //       if (globalVariables[variable] !== undefined) {
  //         globalVars[variable] = globalVariables[variable];
  //       } else {
  //         globalVars[variable] = "";
  //       }
  //     });

  //     setTempGlobalVariables(globalVars);
  //   } else if (formData?.aggregation_type === "flat") {
  //     setTempGlobalVariables({});
  //   }
  // }, [globalVariables, formData?.aggregation_type]);

  useEffect(() => {
    if (linkedServices) {
      setLinkedServicesData(linkedServices);
    }
  }, [linkedServices]);

  // Update context state when auth tags data is fetched (following linkedServicesData pattern)
  useEffect(() => {
    if (authTagsData) {
      setAllAuthTagsData(authTagsData);
    }
  }, [authTagsData, setAllAuthTagsData]);

  // Update context state when system data is fetched (following linkedServicesData pattern)
  useEffect(() => {
    if (systemData) {
      setAllSystemData(systemData);
    }
  }, [systemData, setAllSystemData]);

  useEffect(() => {
    if (fileProcessing) {
      setFileProcessingData(fileProcessing);
    }
  }, [fileProcessing]);

  useEffect(() => {
    if (connectionKeys) {
      setConnectionKeysData(connectionKeys);
    }
  }, [connectionKeys]);

  useEffect(() => {
    if (resourceColumnsData) {
      setResourceColumns(resourceColumnsData);
    }
  }, [resourceColumnsData]);

  useEffect(() => {
    if (resource) {
      setResourceData(resource);
    }
  }, [resource]);

  useEffect(() => {
    if (resourceColumnDataObjData) {
      setResourceColumnDataObj(resourceColumnDataObjData);
    }
  }, [resourceColumnDataObjData]);

  useEffect(() => {
    if (domains) {
      setDomainsData(domains);
    }
  }, [domains]);

  useEffect(() => {
    if (allConnectionKeys) {
      setFetchedConnectionKeys(allConnectionKeys);
    }
  }, [allConnectionKeys]);
  // Track which resource we've already run the one-shot page-load
  // system_id mismatch check for, so subsequent formData mutations
  // (typing, scoring slider moves, etc.) don't re-fire the check and
  // re-hit /connection-key/all repeatedly.
  const checkedSystemIdMismatchForResourceRef = useRef<number | null>(null);

  // Reset the guard when navigating between resources
  useEffect(() => {
    checkedSystemIdMismatchForResourceRef.current = null;
  }, [currentResourceId]);

  // Check for system_id mismatch on page load when data is ready
  useEffect(() => {
    if (
      formData &&
      fetchedConnectionKeys &&
      formData.system_id &&
      checkedSystemIdMismatchForResourceRef.current !== currentResourceId
    ) {
      checkedSystemIdMismatchForResourceRef.current = currentResourceId;
      checkExistingSystemIdMismatch();
    }
  }, [formData, fetchedConnectionKeys, currentResourceId]);

  useEffect(() => {
    setIsLoading(true);
    if (resourceColumnDataObj) {
      Object.keys(resourceColumnDataObj).forEach((key) => {
        delete resourceColumnDataObj[key];
      });
      refetchData();
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (resourceColumnDataObj) {
      setResourceColumnData(resourceColumnDataObj);
      setResourceColumnObj(resourceColumnDataObj);
      if (
        resourceColumnDataObj?.resource_column_properties
          ?.cross_field_validations
      ) {
        const crossFieldWithId =
          resourceColumnDataObj?.resource_column_properties?.cross_field_validations.map(
            (crossField: any) => ({
              ...crossField,
              id: Math.random(),
            }),
          );
        setCrossFieldValidations(crossFieldWithId);
        setInitialCrossFieldValidations(crossFieldWithId);
      }
    }
  }, [resourceColumnDataObj]);

  const unique_columns_data =
    resourceColumnData?.resource_column_properties?.unique_columns;
  // Table Columns
  const columns: GridColDef[] = [
    {
      ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
      renderCell: (params: any) => (
        <IconButton
          size="small"
          tabIndex={-1}
          disabled={
            params?.row?.is_derived ||
            params?.row?.custom_validations?.length > 0 ||
            params?.row?.is_reference ||
            params?.row?.reference_column_definition != null
              ? false
              : true
          }
          onClick={() => {
            // toggle in array
            if (expandedRow.includes(params.row.id)) {
              setExpandedRow((prev: any) =>
                prev.filter((item: any) => item !== params.row.id),
              );
            } else {
              setExpandedRow((prev: any) => [...prev, params.row.id]);
            }
          }}
        >
          {params?.row?.is_derived ||
          params?.row?.custom_validations?.length > 0 ||
          params?.row?.is_reference ||
          params?.row?.reference_column_definition != null ? (
            <ExpandMoreIcon
              sx={{
                transform: `rotateZ(${
                  expandedRow.includes(params.row.id) ? 180 : 0
                }deg)`,
                transition: (theme) =>
                  theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shortest,
                  }),
              }}
              fontSize="inherit"
            />
          ) : null}
        </IconButton>
      ),
    },
    {
      field: "column_name",
      headerName: "Resource Column",
      width: 120,
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <ResourceColumnNameCell
            params={params}
            fileData={fileData}
            setFileData={setFileData}
            manageAvailableColumns={manageAvailableColumns}
            availColumns={availColumns}
            setAvailColumns={setAvailColumns}
            setAvailColumnsWithResourceDetail={
              setAvailColumnsWithResourceDetail
            }
            inputRefs={inputRefs}
          />
        );
      },
    },
    {
      field: "domain_column",
      headerName: "Domain Column",
      width: 120,
      minWidth: 130,
      flex: 1,
      renderCell: (params) => {
        const domainColumnValue = fileData.find(
          (item: any) => item.id === params.row.id,
        )?.domain_column;
        const handleChange = (event: any) => {
          const value = event.target.value;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return { ...item, domain_column: value, changed: true };
              }
              return item;
            }),
          );
        };

        const menuData = selectedDomain?.domain_properties?.columns;
        return (
          <Tooltip title={domainColumnValue} placement="top">
            <NativeSelect
              value={domainColumnValue || ""}
              className="white-space-nowrap form-control capitalize"
              onChange={handleChange}
            >
              <option key={"Select..."} value={""}>
                Select...
              </option>
              {menuData?.length > 0 &&
                menuData.map((domainColumnItem: any) => (
                  <option
                    key={domainColumnItem?.name}
                    value={domainColumnItem?.name}
                  >
                    {domainColumnItem?.name}
                  </option>
                ))}
            </NativeSelect>
          </Tooltip>
        );
      },
    },
    {
      field: "datatype",
      headerName: "Data Type",
      width: 100,
      renderCell: (params) => {
        const dataTypeValue = fileData.find(
          (item: any) => item.id === params.row.id,
        )?.datatype;
        const isDataTypeFilled = dataTypeValue !== "" && dataTypeValue !== null;
        const handleChange = (event: any) => {
          const value = event.target.value;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return {
                  ...item,
                  datatype: value,
                  data_format: "",
                  changed: true,
                };
              }
              return item;
            }),
          );
        };

        return (
          <NativeSelect
            value={dataTypeValue || ""}
            className={`white-space-nowrap format-arrow-pos capitalize ${
              !isDataTypeFilled ? "border-red-parent" : ""
            }`}
            onChange={handleChange}
          >
            <option key={"Select..."} value={""}>
              Select...
            </option>
            {datatypes.map((typeItem) => (
              <option key={typeItem} value={typeItem}>
                {typeItem}
              </option>
            ))}
          </NativeSelect>
        );
      },
    },
    {
      field: "is_mandatory",
      headerName: "Mandatory",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return { ...item, is_mandatory: value, changed: true };
              }
              return item;
            }),
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_masking",
      headerName: "Masking",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return { ...item, is_masking: value, changed: true };
              }
              return item;
            }),
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "key",
      headerName: "Key",
      maxWidth: 60,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                const updatedItem = { ...item, key: value, changed: true };
                // Check if key is true and is_active is false
                if (value && !params.row.is_active) {
                  updatedItem.is_active = true;
                }
                return updatedItem;
              }
              return item;
            }),
          );
        };
        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_reference",
      headerName: "Reference",
      description: "Reference Data",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          if (value) {
            setOpenReferenceDialog(value);
            setSelectedRowId(params.row.id);
            setReferenceData({
              source: "internal",
              source_type: "",
              use_translation: false,
            });
            setFileData((prev: any) => {
              return prev.map((item: any) => {
                if (item.id === params.row.id) {
                  return { ...item, changed: true };
                }
                return item;
              });
            });
          } else {
            setFileData((prev: any) => {
              return prev.map((item: any) => {
                if (item.id === params.row.id) {
                  return {
                    ...item,
                    is_reference: false,
                    reference_column_definition: null,
                    changed: true,
                  };
                }
                return item;
              });
            });
          }
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_active",
      headerName: "Act./Inac.",
      maxWidth: 70,
      align: "center",
      renderCell: (params) => {
        const handleChange = async (event: any) => {
          const value = event.target.checked;
          const isTruthy = ["Y", "y", "Yes", "yes", true, "true"].includes(
            params.row.key,
          );
          if (params.row.is_active === true && isTruthy) {
            showToast(
              `If you want to uncheck 'Active/Inactive,' please uncheck the 'Key' column first.`,
              "warning",
            );
            return;
          }
          const flatAvailColumns = Array.isArray(availColumns)
            ? availColumns
            : (availColumns as any)?.flatColumns || [];
          const updatedColumns = manageAvailableColumns(
            flatAvailColumns,
            params.row.column_name,
            "toggle",
          );
          setAvailColumns(updatedColumns);
          setAvailColumnsWithResourceDetail(null);
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.is_active = value;
              }
              return item;
            }),
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "column_length",
      headerName: "Length",
      width: 100,
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.value;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                const parsedValue = parseInt(value, 10);
                return {
                  ...item,
                  column_length: isNaN(parsedValue) ? null : parsedValue,
                  changed: true,
                };
              }
              return item;
            }),
          );
        };

        // Disable length field for non-string datatypes
        const isDisabled = params.row.datatype !== "string";

        return (
          <Input
            // placeholder="Ex: Enter Sample Length"
            value={
              fileData?.find((item: any) => item.id === params.row.id)
                ?.column_length || ""
            }
            onChange={handleChange}
            onKeyDown={(e: any) => {
              e.stopPropagation();
            }}
            disabled={isDisabled}
            className="form-control input-ellipsis"
          />
        );
      },
    },
    {
      field: "severity_level",
      headerName: "Severity",
      width: 100,
      renderCell: (params) => {
        const severityLevelValue = fileData
          .find((item: any) => item.id === params.row.id)
          ?.severity_level?.toLowerCase();
        const handleChange = (event: any) => {
          const value = event.target.value as string;
          setFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return { ...item, severity_level: value, changed: true };
              }
              return item;
            }),
          );
        };

        return (
          <NativeSelect
            value={severityLevelValue || ""}
            className="white-space-nowrap capitalize"
            onChange={handleChange}
          >
            {severity_level.map((severity: string) => (
              <option key={severity} value={severity}>
                {severity}
              </option>
            ))}
          </NativeSelect>
        );
      },
    },
    {
      field: "data_format",
      headerName: "Format",
      width: 120,
      minWidth: 120,
      flex: 1,
      renderCell: (params) => (
        <ResourceDataFormatCell
          params={params}
          fileData={fileData}
          setFileData={setFileData}
          dateTimeFormat={dateTimeFormat}
        />
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      width: 165,
      renderCell: (params) => {
        const handleDelete = () => {
          setFileData((prev: any) =>
            prev.filter((item: any) => item.id !== params.row.id),
          );
          const flatAvailColumns = Array.isArray(availColumns)
            ? availColumns
            : (availColumns as any)?.flatColumns || [];
          const updatedColumns = manageAvailableColumns(
            flatAvailColumns,
            params.row.column_name,
            "remove",
          );
          setAvailColumns(updatedColumns);
          setAvailColumnsWithResourceDetail(null);
        };

        const handleAddNewRow = () => {
          const newRow = { ...editResourceCDMColumns };
          const currentRowIdx = fileData.findIndex(
            (item: any) => item.id === params.row.id,
          );
          const highestId = fileData.reduce(
            (maxId: any, item: any) => Math.max(maxId, item.id),
            -1,
          );
          newRow.id = highestId + 1;
          const updatedData = [...fileData];
          updatedData.splice(currentRowIdx + 1, 0, newRow);
          setFileData(updatedData);
        };

        return (
          <>
            <Tooltip title="Add Validation" placement="top" arrow>
              <IconButton
                color="inherit"
                onClick={() => {
                  handleAddValidation(params.row.id);
                }}
                className="datagrid-action-btn"
              >
                <IconPlusBase />
              </IconButton>
            </Tooltip>
            {params.row.is_derived && (
              <Tooltip title="Edit Derived Column" placement="top" arrow>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    onAddDerivedColumn();
                    setDerivedModalType("edit");
                    setSelectedRowId(params.row.id);
                  }}
                  className="datagrid-action-btn"
                >
                  <IconEditBase />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Add Column" placement="top" arrow>
              <Button
                color="secondary"
                onClick={handleAddNewRow}
                className="datagrid-action-btn min-width-40"
              >
                <IconAddRowBase />
              </Button>
            </Tooltip>
            <Tooltip title="Delete Row" placement="top" arrow>
              <IconButton
                color="inherit"
                onClick={handleDelete}
                className="datagrid-action-btn"
              >
                <IconDeleteBlueSvg />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  // Use Effets
  useEffect(() => {
    setCurrentResourceId(parseInt(editResourceId));
  }, [editResourceId]);

  useEffect(() => {
    if (resourceColumnData) {
      const resourceColumnVariables =
        resourceColumnData?.resource_column_properties?.inline_variables;
      setGlobalVariables({
        ...globalVariables,
        ...resourceColumnVariables,
      });
      setAllVariablesList((prev: any) => ({
        ...prev,
        resourceColumn: resourceColumnVariables,
      }));
      // setAllVariablesList({
      //   ...allVariablesList,
      //   resourceColumn: resourceColumnVariables,
      // });
      let formattedColumns: any = [];
      const cdmData: any = [];
      const isFileNameOnIdx =
        resourceColumnData?.resource_column_properties?.resource_columns.some(
          (item: any) => item.column_name.toLowerCase() === "file_name",
        );
      resourceColumnData?.resource_column_properties?.resource_columns.map(
        (RColumn: any, idx: any) => {
          if (RColumn?.is_active === true || RColumn?.is_active === undefined) {
            cdmData.push(RColumn["column_name"].trim());
          }
          let severityLevel = "";
          if (RColumn?.severity_level === 1) {
            severityLevel = "High";
          } else if (RColumn?.severity_level === 2) {
            severityLevel = "Medium";
          } else {
            severityLevel = "Low";
          }
          const dataType = (RColumn?.constraints.datatype).toLowerCase();
          formattedColumns.push({
            id: idx,
            column_name: RColumn.column_name,
            domain_column: RColumn.domain_column,
            datatype: datatypes.includes(dataType)
              ? setDataType(dataType)
              : null,
            is_mandatory: RColumn?.constraints.is_mandatory,
            is_masking: RColumn?.constraints.is_masking ?? false,
            data_format: RColumn?.constraints.data_format,
            column_length: RColumn?.constraints.column_length,
            is_derived: RColumn?.constraints.is_derived,
            derived_column_definition:
              RColumn?.constraints.derived_column_definition,
            is_reference: RColumn?.constraints.is_reference,
            reference_column_definition:
              RColumn?.constraints?.reference_column_definition,
            custom_validations: RColumn?.constraints.custom_validations,
            key: unique_columns_data?.includes(RColumn.column_name)
              ? true
              : false,
            severity_level: severityLevel,
            is_active:
              RColumn && RColumn.is_active !== undefined
                ? RColumn.is_active
                : true,
          });
        },
      );
      // if (!isFileNameOnIdx) {
      //   formattedColumns.unshift({ ...defaultEditResourceCDMColumns });
      //   cdmData.unshift("file_name");
      // }

      if (!isFileNameOnIdx) {
        // Unshift the "file_name" column with id 0
        formattedColumns = [
          {
            ...defaultEditResourceCDMColumns,
            id: 0, // Set id to 0
          },
          ...formattedColumns.map((col: any) => ({
            ...col,
            id: col.id + 1, // Shift all other column ids by 1
          })),
        ];

        cdmData.unshift("file_name");
      }
      setFileData(formattedColumns);
      setInitialFileData(JSON.parse(JSON.stringify(formattedColumns)));
      setAvailColumns(cdmData);
      setAvailColumnsWithResourceDetail(null);
    }
  }, [resourceColumnData]);

  useEffect(() => {
    const fetchLinkedData = async () => {
      if (Object.entries(resourceData).length > 0) {
        const resourceVariables =
          resourceData?.additional_properties?.inline_variables;
        setGlobalVariables({
          ...globalVariables,
          ...resourceVariables,
        });
        setAllVariablesList({
          ...allVariablesList,
          resource: resourceVariables,
        });
        // setSelectLinkedServiceId((prev) => resourceData?.linked_service_id);
        setResourceId(
          resourceData?.additional_properties?.aggregation_properties
            ?.base_resource_id ?? 0,
        );
        try {
          const linkedData = linkedServices?.find(
            (item: any) => item.id === resourceData.linked_service_id,
          );
          const newFormData = {
            ...resourceData,
            current_url: resourceData?.current_url
              ? resourceData?.current_url
              : "",
            resource_name: resourceData.resource_name,
            resource_prefix: resourceData.resource_prefix,
            resource_type: resourceData.resource_type,
            domain_id: resourceData.domain_id,
            domain_name: resourceData.domain_name,
            code: resourceData.code,
            resource_column_details_id:
              resourceData?.additional_properties?.resource_column_details_id,
            resource_column_details_code:
              resourceData?.additional_properties?.resource_column_details_code,

            column_details_id:
              resourceData?.additional_properties?.resource_column_details_id,
            file_processing_id: resourceData.file_processing_id,
            resource_definition:
              resourceData?.additional_properties?.resource_definition,
            aggregation_type: resourceData?.aggregation_type,
            base_resource_id:
              resourceData?.additional_properties?.aggregation_properties
                ?.base_resource_id,
            base_resource_code:
              resourceData?.additional_properties?.aggregation_properties
                ?.base_resource_code,
            base_resource_validation:
              resourceData?.additional_properties?.aggregation_properties
                ?.base_resource_validation,
            aggregation_query:
              resourceData?.additional_properties?.aggregation_properties
                ?.aggregation_query,
            base_resource_columns:
              resourceData?.additional_properties?.aggregation_properties
                ?.base_resource_columns,
            filter_rules: resourceData?.additional_properties?.filter_rules
              ? resourceData?.additional_properties?.filter_rules.map(
                  (rule: any) => ({
                    ...rule,
                    id: Math.random(),
                  }),
                )
              : [],
          };
          newFormData.linked_service = linkedData;
          newFormData.system_id = resourceData?.system_id;
          newFormData.resource_tags = Array.isArray(
            resourceData?.resource_tags_details,
          )
            ? resourceData.resource_tags_details.map(
                (tag: any) => tag.auth_tag_id,
              )
            : [];
          newFormData.additional_resource_data =
            resourceData?.additional_properties?.additional_resource_data
              ?.length > 0
              ? resourceData?.additional_properties?.additional_resource_data
              : [];
          setCurrentDomainId(resourceData.domain_id);
          const updatedAdditionalResourceData =
            newFormData.additional_resource_data.map(
              (resource: any, index: number) => ({
                ...resource,
                id: index + 1, // You can use a different logic to generate unique ids
              }),
            );

          let updatedResourceData: any;
          if (
            newFormData.linked_service &&
            newFormData?.resource_definition?.type
          ) {
            let updatedResourceDefinition =
              newFormData?.resource_definition?.[
                `${newFormData?.resource_definition?.type}_definition`
              ];
            if (
              sqlDatabaseType.includes(newFormData?.resource_definition?.type)
            ) {
              updatedResourceDefinition =
                newFormData?.resource_definition?.sql_definition;
            }
            updatedResourceData = {
              ...newFormData,

              additional_resource_data: updatedAdditionalResourceData,
              resource_definition: {
                ...newFormData.resource_definition,
                ...updatedResourceDefinition,
              },
            };
          } else {
            updatedResourceData = {
              ...newFormData,
              additional_resource_data: updatedAdditionalResourceData,
            };
          }
          setFormData(updatedResourceData);
          setInitialFormData(updatedResourceData);
          setCurrentResourceColumnId(newFormData?.resource_column_details_id);
          setQueryParams(
            newFormData?.resource_definition?.api_definition?.query_params ||
              {},
          );
          setUrlParams(
            newFormData?.resource_definition?.api_definition?.url_params || {},
          );
          if (fetchedConnectionKeys) {
            setType(
              fetchedConnectionKeys?.find(
                (option: { id: any }) =>
                  option.id ===
                  resourceData?.additional_properties?.resource_definition
                    ?.api_definition?.connection_key,
              )?.type || " ",
            );
          }
        } catch (error) {
          console.error("Error fetching linked services data:", error);
        }
      }
    };
    fetchLinkedData();
  }, [resourceData, linkedServicesData]);

  // Detect whether the scoring config tab has any unsaved changes
  const scoringConfigChanged = useMemo(() => {
    if (!scoringConfigValues) return false;
    const baseline: any =
      validationScoringConfig ?? validationScoringConfigDefaults;
    return (
      scoringConfigValues.impact_of_record_level !==
        baseline.impact_of_record_level ||
      scoringConfigValues.impact_of_issue_level !==
        baseline.impact_of_issue_level ||
      scoringConfigValues.factor_low !== baseline.factor_low ||
      scoringConfigValues.factor_medium !== baseline.factor_medium ||
      scoringConfigValues.factor_high !== baseline.factor_high
    );
  }, [scoringConfigValues, validationScoringConfig]);

  // Update hasChanges when formData or fileData changes
  useEffect(() => {
    const formChanged =
      JSON.stringify(formData) !== JSON.stringify(initialFormData);
    const fileDataChanged =
      JSON.stringify(fileData) !== JSON.stringify(initialFileData);
    const crossFieldValidationsChanged =
      JSON.stringify(crossFieldValidations) !==
      JSON.stringify(initialCrossFieldValidations);
    setHasChanges(
      formChanged ||
        fileDataChanged ||
        crossFieldValidationsChanged ||
        scoringConfigChanged,
    );
  }, [
    formData,
    fileData,
    initialFormData,
    initialFileData,
    crossFieldValidations,
    initialCrossFieldValidations,
    scoringConfigChanged,
  ]);

  useEffect(() => {
    if (domainsData) {
      const currentDomain = domainsData?.find(
        (domain: any) => domain.id === resourceData?.domain_id,
      );
      setSelectedDomain(currentDomain);
    }
    setCurrentBreadcrumbPage({
      name: resourceData?.resource_name,
      id: resourceData?.id,
    });
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [domainsData, resourceData]);
  // Check for existing system_id mismatch on page load
  const checkExistingSystemIdMismatch = async () => {
    if (!formData?.system_id || !fetchedConnectionKeys) {
      return;
    }
    // Check file type connection key
    const fileConnectionKeyId = formData?.resource_definition?.connection_key;
    if (fileConnectionKeyId && formData?.linked_service?.type === "file") {
      const hasMismatch = await validateSystemIdMismatch(
        fileConnectionKeyId,
        "file",
        true,
      );
      if (hasMismatch) return; // Show only one modal at a time
    }
    // Check SQL type connection key
    const sqlConnectionKeyId = formData?.resource_definition?.connection_key;
    if (sqlConnectionKeyId && formData?.linked_service?.type === "sql") {
      const hasMismatch = await validateSystemIdMismatch(
        sqlConnectionKeyId,
        "sql",
        true,
      );
      if (hasMismatch) return; // Show only one modal at a time
    }
    // Check API type connection key
    const apiConnectionKeyId =
      formData?.resource_definition?.api_definition?.connection_key;
    if (apiConnectionKeyId && formData?.linked_service?.type === "api") {
      await validateSystemIdMismatch(apiConnectionKeyId, "api", true);
    }
  };
  // System ID validation function
  const validateSystemIdMismatch = async (
    connectionKeyId: number | null,
    fieldType: "file" | "sql" | "api",
    isPageLoad: boolean = false,
  ): Promise<boolean> => {
    if (!connectionKeyId || !formData?.system_id) {
      return false; // No validation needed if either is missing
    }
    // Find the selected connection key from all available connection keys
    const connectionKeys = await getAllConnectionKeys([connectionKeyId]);
    const selectedConnectionKey = Array.isArray(connectionKeys)
      ? connectionKeys.find((key: any) => key.id === connectionKeyId) ||
        connectionKeys[0]
      : connectionKeys;
    if (!selectedConnectionKey) {
      return false; // Connection key not found
    }
    // Check if system_ids match
    const resourceSystemId = formData.system_id;
    const connectionKeySystemId = selectedConnectionKey.system_id;
    if (resourceSystemId !== connectionKeySystemId) {
      // System IDs don't match - show warning modal
      setSystemIdMismatchData({
        resourceSystemId,
        connectionKeySystemId,
        connectionKeyName: selectedConnectionKey.name,
        fieldType,
        isPageLoad,
      });
      setShowSystemIdMismatchModal(true);
      return true; // Mismatch detected
    }
    return false; // No mismatch
  };
  // Handle system ID mismatch modal actions
  const handleSystemIdMismatchProceed = () => {
    if (!systemIdMismatchData) return;

    // NEW LOGIC: Update resource system_id to match connection key's system_id
    const updatedFormData = { ...formData };
    updatedFormData.system_id = systemIdMismatchData.connectionKeySystemId;

    // Update form data with new system_id
    setFormData(updatedFormData);

    // Close modal
    setShowSystemIdMismatchModal(false);
    setSystemIdMismatchData(null);
  };

  const handleSystemIdMismatchCancel = () => {
    if (!systemIdMismatchData) return;

    // NEW LOGIC: Clear the connection_key field (old "Continue" behavior)
    const updatedFormData = { ...formData };

    if (systemIdMismatchData.fieldType === "file") {
      if (updatedFormData.resource_definition) {
        updatedFormData.resource_definition.connection_key = null;
      }
    } else if (systemIdMismatchData.fieldType === "sql") {
      if (updatedFormData.resource_definition) {
        updatedFormData.resource_definition.connection_key = null;
      }
    } else if (systemIdMismatchData.fieldType === "api") {
      if (updatedFormData.resource_definition?.api_definition) {
        updatedFormData.resource_definition.api_definition.connection_key =
          null;
      }
    }

    // Set error message for the cleared connection key field
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      connection_key:
        "Connection key was cleared due to system ID mismatch. Please select a compatible connection key.",
    }));

    // Open the "Connection Details" accordion (linkedService)
    setExpandedAccordion("linkedService");

    setFormData(updatedFormData);
    setShowSystemIdMismatchModal(false);
    setSystemIdMismatchData(null);
  };

  const prepareAvailableColumnsForQueryBuilder = () => {
    const baseColumns = fileData.map((item: any) => item?.column_name);

    if (
      formData?.additional_resource_data?.length > 0 &&
      allResourcesAdditionalData?.length > 0 &&
      resourceColumnsFromContext?.length > 0
    ) {
      const resourceColumnIds = formData.additional_resource_data.map(
        (res: any) => res.resource_id,
      );
      const updatedColumnsData = resourceColumnIds.map((res_id: any) => {
        const resource_column_ids = allResourcesAdditionalData?.find(
          (res1: { id: number }) => res1.id === res_id,
        )?.additional_properties?.resource_column_details_id;

        const resource_column = (resourceColumnsFromContext as any)?.find(
          (res1: { id: number }) => res1.id === resource_column_ids,
        )?.resource_column_properties?.resource_columns;
        return {
          resource_id: res_id,
          resource_columns: resource_column,
        };
      });

      const additionalResourceColumnInfo = buildAdditionalResourceColumnInfo(
        formData.additional_resource_data,
        allResourcesAdditionalData,
        updatedColumnsData,
      );

      const structuredColumns = mergeResourceColumnsWithMetadata(
        baseColumns,
        additionalResourceColumnInfo,
        allResourcesAdditionalData,
      );
      setAvailColumns(structuredColumns);
    } else {
      setAvailColumns(baseColumns);
    }
    setAvailColumnsWithResourceDetail(null);
  };

  // Handle Events
  const handleAddValidation = (id: any) => {
    prepareAvailableColumnsForQueryBuilder();
    setSelectedRowId(id);
    setOpenValidationDialog(true);
  };
  const handleEditValidationDialog = (id: any, index: number) => {
    prepareAvailableColumnsForQueryBuilder();
    setOpenValidationDialog(true);
    setIsDailogEdit(true);
    setSelectedRowId(id);
    setDailogEditIndex(index);
  };
  const handleDeleteValidation = (index: number, rowId: number) => {
    const updatedData = fileData
      .find((row: any) => row.id === rowId)
      ?.custom_validations?.filter((item: any, i: number) => i !== index);
    setFileData((prev: any) => {
      const newData = prev.map((item: any) => {
        if (item.id === rowId) {
          item.custom_validations = updatedData;
        }
        return item;
      });
      return newData;
    });
  };

  const handleEditReferenceDialog = (
    id: any,
    connectionKeys: any,
    linkedServices: any,
  ) => {
    const row = fileData?.[id];

    if (!row || !row.reference_column_definition) {
      return;
    }

    const refDef = row.reference_column_definition;

    const referenceData = {
      source: refDef?.source ?? "",
      source_type: refDef?.source_type ?? "",
      use_translation: refDef?.use_translation ?? false,

      connection_key:
        connectionKeys.find(
          (connectionKey: any) => connectionKey?.id === refDef?.connection_key,
        ) || null,

      linked_service:
        linkedServices.find(
          (service: any) => service?.id === refDef?.linked_service_id,
        ) || null,

      inline_variables: refDef?.inline_variables ?? [],
    };

    setOpenReferenceDialog(true);
    setSelectedRowId(id);
    setReferenceData(referenceData);
  };

  const handleDeleteReference = (rowId: number) => {
    setFileData((prev: any) => {
      return prev.map((item: any) => {
        if (item.id === rowId) {
          item.is_reference = false;
          item.reference_column_definition = null;
        }
        return item;
      });
    });
  };
  // Set forma data in state
  const handleFormData = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    validateField(e.target.name, e.target.value);
  };
  const checkFilterRuleValidation = async (
    updatedFormData: any,
    schemaType: any,
  ) => {
    const getSchemaType =
      schemaType === "name" ? filterRulesNameSchema : filterRulesSqlSchema;
    for (let index = 0; index < updatedFormData.filter_rules.length; index++) {
      const element = updatedFormData.filter_rules[index];
      try {
        await getSchemaType.validate(element, { abortEarly: false });
        const updatedJsonData = { ...errors };
        const updateKey = schemaType === "name" ? "name" : "sql_query";
        if (updatedJsonData?.filter_rules?.length > index) {
          updatedJsonData.filter_rules[index][updateKey] = undefined;
        } else {
          updatedJsonData.filter_rules.push({ [updateKey]: undefined });
        }
        setErrors(updatedJsonData);
      } catch (validationErrors: any) {
        const updatedJsonData = { ...errors };
        const updateKey = schemaType === "name" ? "name" : "sql_query";
        if (updatedJsonData?.filter_rules?.length > index) {
          updatedJsonData.filter_rules[index][updateKey] =
            validationErrors.message;
        } else {
          updatedJsonData.filter_rules.push({
            [updateKey]: validationErrors.message,
          });
        }
        setErrors(updatedJsonData);
      }
    }
  };
  const validateLinkedServiceField = async (name: any, value: any) => {
    try {
      let partialFormData;
      let validateFieldName;
      const type = formData?.linked_service?.sub_type;
      if (name === "linked_service" || name === "file_processing_id") {
        partialFormData = { ...formData, [name]: value };
        validateFieldName = name;
      } else {
        partialFormData = {
          resource_definition: {
            [name]: value,
          },
        };
        validateFieldName = `resource_definition.${name}`;
      }
      if (type === "blob") {
        await blobDefinitionSchema.validateAt(
          validateFieldName,
          partialFormData,
        );
      } else if (type === "sftp") {
        await sftpDefinitionSchema.validateAt(
          validateFieldName,
          partialFormData,
        );
      } else if (type === "local") {
        await localDefinitionSchema.validateAt(
          validateFieldName,
          partialFormData,
        );
      } else {
        await sqlDefinitionSchema.validateAt(
          validateFieldName,
          partialFormData,
        );
      }
      setErrors((prevErrors: any) => ({ ...prevErrors, [name]: undefined }));
    } catch (validationError: any) {
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        [name]: validationError.message,
      }));
    }
  };
  const matchSqlQueryWithColumns = (
    filterRules: any[],
    columns: string[],
    setErrors: Function,
    availableColumns: string[],
  ) => {
    let hasInvalidRules = false;
    // Prepare initial errors array or empty array
    setErrors((prevErrors: any) => {
      const prevFilterErrors = Array.isArray(prevErrors.filter_rules)
        ? prevErrors.filter_rules
        : [];
      // We'll create a new errors array with length = filterRules.length
      const newFilterErrors = filterRules.map((rule, idx) => {
        // Extract columns from sql_query (replace with your extractor)
        const usedColumns = extractDollarPrefixedColumns(rule.sql_query);
        const isValid = usedColumns.every((col) =>
          isResourceColumnNameValid(col, columns)
        );
        if (!isValid) hasInvalidRules = true;
        // Preserve existing error if valid, else set new error message
        const existingError = prevFilterErrors[idx] || {};
        return {
          ...existingError,
          sql_query: !isValid ? "Invalid column(s) in SQL query" : "",
        };
      });
      return {
        ...prevErrors,
        filter_rules: newFilterErrors,
      };
    });

    // Return the rules with validity flags
    const updatedRules = filterRules.map((rule) => {
      const usedColumns = extractDollarPrefixedColumns(rule.sql_query);
      return {
        ...rule,
        isValid: usedColumns.every((col) =>
          isResourceColumnNameValid(col, columns)
        ),
      };
    });
    return { updatedRules, hasInvalidRules };
  };

  const validateField = async (name: any, value: any) => {
    try {
      const partialFormData = { ...formData, [name]: value };
      await addEditResourceSchema.validateAt(name, partialFormData);
      setErrors((prevErrors: any) => ({ ...prevErrors, [name]: undefined }));
    } catch (validationError: any) {
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        [name]: validationError.message,
      }));
    }
  };
  const validateApiDefinitionField = async (name: any, value: any) => {
    try {
      const partialFormData = {
        resource_definition: {
          api_definition: {
            [name]: value,
          },
        },
      };
      const validateFieldName = `resource_definition.api_definition.${name}`;
      // const type = formData?.linked_service?.sub_type;
      if (type === "basic_auth_api") {
        await basicAuthApiSchema.validateAt(validateFieldName, partialFormData);
      } else if (type === "token_auth_api") {
        await tokenAuthApiSchema.validateAt(validateFieldName, partialFormData);
      } else if (type === "key_auth_api") {
        await keyAuthApiSchema.validateAt(validateFieldName, partialFormData);
      } else if (type === "oauth_api") {
        await oAuthApiSchema.validateAt(validateFieldName, partialFormData);
      } else if (type === "no_auth_api") {
        await noAuthApiSchema.validateAt(validateFieldName, partialFormData);
      }
      setErrors((prevErrors: any) => ({ ...prevErrors, [name]: undefined }));
    } catch (validationError: any) {
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        [name]: validationError.message,
      }));
    }
  };

  /**
   * Removes server-side / UI-only keys from a resource body object in-place.
   * Called by both buildPayload (View JSON) and onSaveResource (API call)
   * so that both surfaces always produce the same cleaned shape.
   */
  const cleanResourceBody = (body: any, linkedServiceType?: string): void => {
    [
      "resource_location",
      "resource_path",
      "column_details_id",
      "linked_service",
      "resource_definition",
      "base_resource_id",
      "base_resource_code",
      "aggregation_query",
      "base_resource_columns",
      "base_resource_validation",
      "additional_resource_data",
      "filter_rules",
      "resource_column_details_id",
      "resource_column_details_code",
      "resource_tags_details",
    ].forEach((key) => delete body[key]);

    if (linkedServiceType === "sql") {
      const sqlKeysToRemove = [
        "file_processing_code",
        "file_processing_id",
        "column_delimiter",
        "container_name",
        "file_name",
        "resource_path",
        "database_type",
        "connection_string",
      ];
      sqlKeysToRemove.forEach((key) => {
        if (key in body) {
          delete body[key];
        } else if (
          body.additional_properties?.resource_definition?.sql_definition &&
          key in body.additional_properties.resource_definition.sql_definition
        ) {
          delete body.additional_properties.resource_definition.sql_definition[
            key
          ];
        }
      });
    }
  };

  const buildPayload = () => {
    // ── columns (identical logic to onSaveResource) ──────────────────────────
    const uniqueData: string[] = [];
    fileData.forEach((item: any) => {
      if (item?.key) uniqueData.push(item?.column_name);
    });

    const columns = fileData.map((fileItem: any) => {
      const constraints: any = {
        datatype: fileItem?.datatype,
        is_mandatory: Boolean(fileItem["is_mandatory"]),
        is_masking: Boolean(fileItem["is_masking"]),
        data_format: fileItem?.data_format,
        column_length: fileItem?.column_length ? fileItem?.column_length : null,
      };
      if (fileItem?.is_reference) {
        constraints["is_reference"] = fileItem?.is_reference;
        constraints["reference_column_definition"] =
          fileItem?.reference_column_definition;
      }
      if (fileItem?.is_derived) {
        constraints["is_derived"] = fileItem?.is_derived;
        constraints["derived_column_definition"] =
          fileItem?.derived_column_definition;
      }
      constraints["custom_validations"] =
        fileItem?.custom_validations?.length > 0
          ? fileItem?.custom_validations
          : null;
      return {
        column_name: fileItem?.column_name,
        domain_column: fileItem?.domain_column,
        is_active: fileItem?.is_active,
        severity_level:
          fileItem.severity_level === "high" ||
          fileItem.severity_level === "High"
            ? 1
            : fileItem.severity_level === "medium" ||
                fileItem.severity_level === "Medium"
              ? 2
              : 3,
        constraints,
      };
    });

    // ── additional_properties (mirrors onSaveResource's reqBody1) ─────────────
    const normalizeKeys = (obj: Record<string, any> = {}) =>
      Object.keys(obj).reduce(
        (acc: Record<string, any>, key: string) => {
          acc[key.toLowerCase()] = (obj as any)[key];
          return acc;
        },
        {} as Record<string, any>,
      );

    let additional_properties: any;

    if (formData.aggregation_type === "flat") {
      let definitionType = formData?.resource_definition?.type + "_definition";
      if (sqlDatabaseType.includes(formData?.resource_definition?.type)) {
        definitionType = "sql_definition";
      }
      additional_properties = {
        resource_definition: {
          type: formData?.resource_definition?.type,
          [definitionType]: {
            resource_path: formData?.resource_definition?.resource_path,
            file_name: formData?.resource_definition?.file_name,
            excel_sheet_name: formData?.resource_definition?.excel_sheet_name,
            column_delimiter: formData?.resource_definition?.column_delimiter,
            connection_key: formData?.resource_definition?.connection_key,
            connection_key_code: connectionKeysData?.find(
              (option: { id: any }) =>
                option.id === formData?.resource_definition?.connection_key,
            )?.code,
            container_name: formData?.resource_definition?.container_name,
            database_type: formData?.resource_definition?.database_type,
            connection_string: formData?.resource_definition?.connection_string,
            sql_query: formData?.resource_definition?.sql_query,
            column_name_to_partition_on_sql_query:
              formData?.resource_definition
                ?.column_name_to_partition_on_sql_query,
            use_multi_thread_reader:
              formData?.resource_definition?.use_multi_thread_reader,
            remote_directory: formData?.resource_definition?.remote_directory,
            use_parquet_export:
              formData?.resource_definition?.use_parquet_export || false,
            parquet_export_definition: formData?.resource_definition
              ?.use_parquet_export
              ? formData?.resource_definition?.parquet_export_definition
              : null,
          },
          api_definition: apiType.includes(type)
            ? {
                ...formData?.resource_definition?.api_definition,
                query_params: queryParams,
                url_params: urlParams,
                body:
                  formData?.resource_definition?.api_definition?.method !==
                  "get"
                    ? formData?.resource_definition?.api_definition?.body
                    : null,
                connection_key_code: connectionKeysData?.find(
                  (option: { id: any }) =>
                    option.id ===
                    formData?.resource_definition?.api_definition
                      ?.connection_key,
                )?.code,
              }
            : null,
        },
        resource_column_details_id: parseInt(formData.column_details_id),
        resource_column_details_code: formData?.resource_column_details_code,
        additional_resource_data:
          formData?.additional_resource_data?.length > 0
            ? formData?.additional_resource_data
            : [],
        filter_rules: formData.filter_rules
          ? formData.filter_rules.map(
              ({ id, ...filterRest }: { id: number }) => filterRest,
            )
          : null,
        inline_variables: { ...normalizeKeys(globalVariables) },
      };
    } else {
      // aggregated
      let uniqueBaseResourceColumns: any = null;
      if (baseResourceColumns && baseResourceColumns.length > 0) {
        const uniqueSet = new Set(
          baseResourceColumns.map((column: { label: any }) => column.label),
        );
        uniqueBaseResourceColumns = Array.from(uniqueSet);
      }
      additional_properties = {
        resource_column_details_id: parseInt(formData.column_details_id),
        resource_column_details_code: formData?.resource_column_details_code,
        resource_definition: null,
        additional_resource_data:
          formData?.additional_resource_data?.length > 0
            ? formData?.additional_resource_data
            : [],
        aggregation_properties: {
          base_resource_id: formData.base_resource_id,
          base_resource_code: formData.base_resource_code,
          aggregation_query: formData.aggregation_query,
          base_resource_columns: uniqueBaseResourceColumns,
          base_resource_validation: formData.base_resource_validation,
        },
        filter_rules: formData.filter_rules
          ? formData.filter_rules.map(
              ({ id, ...filterRest }: { id: number }) => filterRest,
            )
          : null,
      };
    }

    // ── resourceBody (mirrors modifiedReqBody from onSaveResource) ────────────
    const { resource_tags, ...rest } = formData;
    const resourceBodyResource: any = {
      ...rest,
      linked_service_id: formData?.linked_service?.id || null,
      linked_service_code: formData?.linked_service?.code || null,
      resource_type: formData?.resource_type,
      name: formData?.resource_prefix,
      is_active: true,
      file_attribute_code: formData?.file_processing_id
        ? fileProcessingData?.find(
            (option: { id: any }) => option.id === formData?.file_processing_id,
          )?.code
        : "",
      additional_properties,
    };
    cleanResourceBody(resourceBodyResource, formData?.linked_service?.type);

    const resourceBody = {
      resource: resourceBodyResource,
      resource_tags,
    };

    // ── columnDetailsBody (mirrors modifiedReqBody2 from onSaveResource) ──────
    const columnDetailsBody = {
      resource_column_details: {
        domain_id: currentDomainId,
        resource_type: formData.resource_type,
        name: resourceColumnData?.name,
        code: formData.code,
        domain_code: formData.domain_code,
        resource_tags: formData.resource_tags,
        is_active: true,
        comment: formData.comment,
        resource_column_properties: {
          cross_field_validations: crossFieldValidations,
          unique_columns: uniqueData,
          resource_columns: columns,
          inline_variables: allVariablesList?.resourceColumn || {},
        },
      },
      resource_column_details_tags: formData.resource_tags,
    };

    return {
      resource: resourceBody,
      resource_column_details: columnDetailsBody,
    };
  };

  const handleValidatePayload = async (
    payload: any,
    section?: "resource" | "resource_column_details",
  ) => {
    setIsValidating(true);
    try {
      const validateReqBody =
        section === "resource_column_details"
          ? {
              target_endpoint: `/resources-columns/${currentResourceColumnId}`,
              method: "PUT",
              body: payload?.resource_column_details,
              query_params: {},
              url_params: { id: currentResourceColumnId },
            }
          : {
              target_endpoint: `/resources/${currentResourceId}`,
              method: "PUT",
              body: payload?.resource,
              query_params: {},
              url_params: { id: currentResourceId },
            };
      const response = await validateConfigRequest(validateReqBody);
      setValidationResponse(response);
      if (response?.is_valid) {
        showToast("Payload is valid!", "success");
      }
    } catch (error: any) {
      showToast(error?.response?.data?.message || "Validation failed", "error");
    } finally {
      setIsValidating(false);
    }
  };

  const handleCopyPayload = async () => {
    const payload = buildPayload();
    await navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
    showToast("Payload copied to clipboard!", "success");
  };

  const handleValidations = async () => {
    if (!canSaveScoringConfig) {
      showToast(
        "Please fix the scoring configuration errors before saving.",
        "error",
      );
      return;
    }
    let uniqueBaseResourceColumns;
    if (baseResourceColumns && baseResourceColumns.length > 0) {
      const uniqueColumns = new Set(
        baseResourceColumns.map((column: { label: any }) => column.label),
      );
      uniqueBaseResourceColumns = Array.from(uniqueColumns);
    } else {
      uniqueBaseResourceColumns = null;
    }
    const updatedFormData = {
      ...formData,
      domain_id: formData.domain_id || currentDomainId,
      resource_type: formData?.resource_prefix || "",
      resource_column_details_id:
        formData.resource_column_details_id || currentResourceColumnId,
      base_resource_columns: uniqueBaseResourceColumns,
    };
    try {
      for (const column of fileData) {
        const definition = column?.reference_column_definition;
        if (definition?.source === "external") {
          if (
            !(definition?.linked_service_id ?? "") ||
            !(definition?.connection_key ?? "")
          ) {
            showToast(`Please Update Reference Definition`, "error");
            return;
          }
        }
        if (column.column_name === "" || column.datatype === "") {
          showToast(
            `Please fill in all "Resource column" and "Data Type" fields`,
            "warning",
          );
          return;
        } else if (
          column.datatype === "datetime" &&
          (column.data_format === null || column.data_format === "")
        ) {
          showToast(`Please fill in all "Format" field`, "warning");
          return;
        }
      }
      const availableColumns =
        fileData?.map((item: any) => item?.column_name) || [];

      // merge the availColumns with availableColumns
      const mergedColumns = [
        ...(Array.isArray(availableColumns) ? availableColumns : []),
        ...(Array.isArray(availColumns) ? availColumns : []),
      ];
      setIsSaveClicked(!isSaveClicked);
      const reqBody1: any = {};
      const availColumnSchemaObj: any = {};
      Object.keys(tempGlobalVariables).map((key: any) => {
        if (tempGlobalVariables[key] === "") {
          availColumnSchemaObj[key] = Yup.string().required(
            `Please enter ${key}`,
          );
          setErrors((prevErrors: any) => ({
            ...prevErrors,
            [key]: `Please enter ${key}`,
          }));
        }
      });

      const availColumnSchema = Yup.object().shape(availColumnSchemaObj);
      await availColumnSchema.validate(updatedFormData, {
        abortEarly: false,
      });

      if (formData.aggregation_type === "flat") {
        await addEditResourceSchema.validate(updatedFormData, {
          abortEarly: false,
        });
        if (formData?.linked_service?.sub_type === "local") {
          await localDefinitionSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "blob") {
          await blobDefinitionSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "sftp") {
          await sftpDefinitionSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (
          sqlDatabaseType.includes(formData?.linked_service?.sub_type)
        ) {
          await sqlDefinitionSchema.validate(updatedFormData, {
            abortEarly: false,
          });

          // Additional validation for column_name_to_partition_on_sql_query when use_multi_thread_reader is true
          if (
            formData.use_multi_thread_reader &&
            (!formData.resource_definition
              ?.column_name_to_partition_on_sql_query ||
              formData.resource_definition.column_name_to_partition_on_sql_query.trim() ===
                "")
          ) {
            setErrors((prevErrors: any) => ({
              ...prevErrors,
              column_name_to_partition_on_sql_query:
                "Column name to partition on is required when multi-thread reader is enabled",
            }));
            throw new Error(
              "Column name to partition on is required when multi-thread reader is enabled",
            );
          }
        } else if (formData?.linked_service?.sub_type === "basic_auth_api") {
          await basicAuthApiSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "token_auth_api") {
          await tokenAuthApiSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "key_auth_api") {
          await keyAuthApiSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "oauth_api") {
          await oAuthApiSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        } else if (formData?.linked_service?.sub_type === "no_auth_api") {
          await noAuthApiSchema.validate(updatedFormData, {
            abortEarly: false,
          });
        }
        if (formData?.filter_rules.length > 0) {
          const isValidFilterRules = formData?.filter_rules.every(
            (filter: { name: undefined; sql_query: undefined }) => {
              return filter.name !== "" && filter.sql_query !== "";
            },
          );
          if (!isValidFilterRules) {
            return;
          }
        }
        let definitionType =
          formData?.resource_definition?.type + "_definition";
        if (sqlDatabaseType.includes(formData?.resource_definition?.type)) {
          definitionType = "sql_definition";
        }
        Object.assign(reqBody1, {
          ...formData,
          linked_service_id: formData.linked_service.id,
          linked_service_code: formData.linked_service.code,
          resource_type: formData.resource_type,
          name: formData.resource_prefix,
          is_active: true,
          file_attribute_code: formData?.file_processing_id
            ? fileProcessingData?.find(
                (option: { id: any }) =>
                  option.id === formData?.file_processing_id,
              )?.code
            : "",
          additional_properties: {
            resource_definition: {
              type: formData?.resource_definition?.type,
              [definitionType]: {
                resource_path: formData?.resource_definition?.resource_path,
                file_name: formData?.resource_definition?.file_name,
                excel_sheet_name:
                  formData?.resource_definition?.excel_sheet_name,
                column_delimiter:
                  formData?.resource_definition?.column_delimiter,
                connection_key: formData?.resource_definition?.connection_key,
                connection_key_code: connectionKeysData?.find(
                  (option: { id: any }) =>
                    option.id === formData?.resource_definition?.connection_key,
                )?.code,
                container_name: formData?.resource_definition?.container_name,
                database_type: formData?.resource_definition?.database_type,
                connection_string:
                  formData?.resource_definition?.connection_string,
                sql_query: formData?.resource_definition?.sql_query,
                column_name_to_partition_on_sql_query:
                  formData?.resource_definition
                    ?.column_name_to_partition_on_sql_query,
                use_multi_thread_reader:
                  formData?.resource_definition?.use_multi_thread_reader,
                remote_directory:
                  formData?.resource_definition?.remote_directory,
                use_parquet_export:
                  formData?.resource_definition?.use_parquet_export || false,
                parquet_export_definition: formData?.resource_definition
                  ?.use_parquet_export
                  ? formData?.resource_definition?.parquet_export_definition
                  : null,
              },
              api_definition: apiType.includes(type)
                ? {
                    ...formData?.resource_definition?.api_definition,
                    query_params: queryParams,
                    url_params: urlParams,
                    body:
                      formData?.resource_definition?.api_definition?.method !==
                      "get"
                        ? formData?.resource_definition?.api_definition?.body
                        : null,
                    connection_key_code: connectionKeysData?.find(
                      (option: { id: any }) =>
                        option.id ===
                        formData?.resource_definition?.api_definition
                          ?.connection_key,
                    )?.code,
                  }
                : null,
            },
            resource_column_details_id: parseInt(formData.column_details_id),
            resource_column_details_code:
              formData?.resource_column_details_code,
            additional_resource_data:
              formData?.additional_resource_data?.length > 0
                ? formData?.additional_resource_data
                : [],
            filter_rules: formData.filter_rules
              ? formData.filter_rules.map(
                  ({ id, ...rest }: { id: number }) => rest,
                )
              : null,
          },
        });
      } else if (formData.aggregation_type === "aggregated") {
        await addNewResourceNewDomainWithoutLinkedServiceSchema.validate(
          updatedFormData,
          {
            abortEarly: false,
          },
        );
        await aggregatedValidateSchema.validate(updatedFormData, {
          abortEarly: false,
        });
        Object.assign(reqBody1, {
          ...formData,
          linked_service_id: null,
          linked_service_code: null,
          resource_type: formData?.resource_prefix || "",
          is_active: true,
          additional_properties: {
            ...reqBody1.additional_properties,
            resource_column_details_id: parseInt(formData.column_details_id),
            resource_column_details_code:
              formData?.resource_column_details_code,
            resource_definition: null,
            additional_resource_data:
              formData?.additional_resource_data?.length > 0
                ? formData?.additional_resource_data
                : [],
            aggregation_properties: {
              base_resource_id: formData.base_resource_id,
              base_resource_code: formData.base_resource_code,
              aggregation_query: formData.aggregation_query,
              base_resource_columns: uniqueBaseResourceColumns,
              base_resource_validation: formData.base_resource_validation,
            },
            filter_rules: formData.filter_rules
              ? formData.filter_rules.map(
                  ({ id, ...rest }: { id: number }) => rest,
                )
              : null,
          },
        });
      }
      const allKeysBlank = fileData.every(
        (obj: any) =>
          obj.key === null ||
          obj.key === undefined ||
          obj.key === "" ||
          obj.key === false ||
          obj.key === "false",
      );
      if (fileData.length > 0 && fileData[0]?.column_name === "file_name") {
        if (fileData.length < 2) {
          showToast(`Please add at least one row`, "error");
          return;
        }
        if (fileData.length > 1 && allKeysBlank) {
          showToast(`Please provide a key for at least one field.`, "warning");
          return;
        }
      }
      const resource_Ids = new Set();

      for (const additionalRes of formData?.additional_resource_data) {
        if (
          additionalRes.resource_id === null ||
          additionalRes.base_column_names.length === 0 ||
          additionalRes.add_on_column_names.length === 0
        ) {
          return;
        }
        // Check if resource_id is unique
        if (resource_Ids.has(additionalRes.resource_id)) {
          return;
        }
        additionalRes.generate_derived_columns_before_merge_additional_resource ??= false;

        resource_Ids.add(additionalRes.resource_id);
        // Check if base_column_names and add_on_column_names have the same length
        if (
          additionalRes.base_column_names.length !==
          additionalRes.add_on_column_names.length
        ) {
          showToast(
            "Please select same number of columns in additional resources",
            "warning",
          );
          return;
        }
        // delete additionalRes.id;
      }
      if (formData?.filter_rules && formData?.filter_rules.length > 0) {
        const isValidFilterRules = formData?.filter_rules.every(
          (adhoc: { name: undefined; sql_query: undefined }) => {
            return adhoc.name !== "" && adhoc.sql_query !== "";
          },
        );
        if (!isValidFilterRules) {
          checkFilterRuleValidation(updatedFormData, "name");
          checkFilterRuleValidation(updatedFormData, "sql_query");
          return;
        }
      }

      if (crossFieldValidations && crossFieldValidations.length > 0) {
        const isValidCrossFieldValidations = crossFieldValidations.every(
          (adhoc: { name: undefined; sql_query: undefined }) => {
            return adhoc.name !== "" && adhoc.sql_query !== "";
          },
        );
        if (!isValidCrossFieldValidations) {
          showToast(
            "Name and SQL Query cannot be empty in Adhoc Query!",
            "warning",
          );
          return;
        }
      }
      const { hasInvalidRules } = matchSqlQueryWithColumns(
        formData.filter_rules,
        mergedColumns,
        setErrors,
        availableColumns,
      );
      if (hasInvalidRules) {
        showToast(
          "Please match column names with available columns under filter rules",
          "warning",
        );
        return;
      }
      setOpenCommentConfirmation(true);
      return { reqBody1, updatedFormData };
    } catch (validationErrors: any) {
      const newErrors: { [key: string]: string } = {};
      if (validationErrors.inner) {
        validationErrors.inner.forEach(
          (error: { path: string | number; message: string }) => {
            const fieldName = String(error.path).replace(
              /^resource_definition(\.api_definition)?\./,
              "",
            );
            newErrors[fieldName] = error.message;
          },
        );
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors((prevErrors: any) => ({
          ...prevErrors,
          ...newErrors,
        }));
        return;
      }
    }
  };

  // Silently persist scoring config alongside a resource update
  const persistScoringConfigSilently = (
    resourceId: number,
    comment: string,
  ) => {
    if (!scoringConfigValues || !resourceId) return;
    const basePayload = {
      impact_of_record_level: scoringConfigValues.impact_of_record_level,
      impact_of_issue_level: scoringConfigValues.impact_of_issue_level,
      factor_low: scoringConfigValues.factor_low,
      factor_medium: scoringConfigValues.factor_medium,
      factor_high: scoringConfigValues.factor_high,
    };
    const existingId = validationScoringConfig?.id;
    const request =
      existingId && existingId > 0
        ? updateValidationScoringConfig(existingId, {
            ...basePayload,
            comment: comment || "",
          })
        : createValidationScoringConfig({
            resource_id: resourceId,
            ...basePayload,
          });
    request.catch((error) => {
      console.error(
        "Failed to persist scoring config for resource:",
        resourceId,
        error,
      );
      showToast(
        "Resource was updated but the scoring config could not be saved. You can adjust it later from the Scoring Config tab.",
        "warning",
      );
    });
  };

  // handel event when we save a resource
  const onSaveResource = async (event: any) => {
    if (!canSaveScoringConfig) {
      showToast(
        "Please fix the scoring configuration errors before saving.",
        "error",
      );
      return;
    }
    const { reqBody1, updatedFormData }: any = await handleValidations();
    const columns = fileData.map((fileItem: any) => {
      const constraints: any = {
        datatype: fileItem?.datatype,
        is_mandatory: Boolean(fileItem["is_mandatory"]),
        is_masking: Boolean(fileItem["is_masking"]),
        data_format: fileItem?.data_format,
        column_length: fileItem?.column_length ? fileItem?.column_length : null,
      };
      if (fileItem?.is_reference) {
        constraints["is_reference"] = fileItem?.is_reference;
        constraints["reference_column_definition"] =
          fileItem?.reference_column_definition;
      }
      if (fileItem?.is_derived) {
        constraints["is_derived"] = fileItem?.is_derived;
        constraints["derived_column_definition"] =
          fileItem?.derived_column_definition;
      }
      if (fileItem?.custom_validations?.length > 0) {
        constraints["custom_validations"] = fileItem?.custom_validations;
      } else {
        constraints["custom_validations"] = null;
      }
      return {
        column_name: fileItem?.column_name,
        domain_column: fileItem?.domain_column,
        severity_level:
          fileItem?.severity_level === "high" ||
          fileItem?.severity_level === "High"
            ? 1
            : fileItem?.severity_level === "medium" ||
                fileItem?.severity_level === "Medium"
              ? 2
              : 3,
        is_active: fileItem?.is_active,
        constraints,
      };
    });

    try {
      const resourceColumnId = formData.column_details_id;

      cleanResourceBody(reqBody1, formData?.linked_service?.type);

      // for (const key in tempGlobalVariables) {
      //   const lowercaseKey = key;
      //   if (globalVariables.hasOwnProperty(lowercaseKey)) {
      //     // If the lowercase key exists in globalVar, update its value
      //     globalVariables[lowercaseKey] = tempGlobalVariables[key];
      //   } else {
      //     // If the lowercase key doesn't exist in globalVar, add it
      //     globalVariables[lowercaseKey] = tempGlobalVariables[key];
      //   }
      // }

      // Normalize variable keys to lowercase and merge temp variables to avoid case-based duplicates
      const normalizeKeys = (obj: Record<string, any> = {}) =>
        Object.keys(obj).reduce(
          (acc: Record<string, any>, key: string) => {
            acc[key.toLowerCase()] = (obj as any)[key];
            return acc;
          },
          {} as Record<string, any>,
        );

      const mergedInlineVariables = {
        ...normalizeKeys(globalVariables),
      };

      reqBody1.additional_properties.inline_variables = mergedInlineVariables;
      const uniqueData: any = [];
      fileData.forEach((item: any) => {
        if (item?.key) {
          uniqueData.push(item?.column_name);
        }
      });
      const reqBody2 = {
        domain_id: currentDomainId,
        resource_type: formData.resource_type,
        name: resourceColumnData.name,
        code: formData.code,
        domain_code: formData.domain_code,
        resource_tags: formData.resource_tags,
        is_active: true,
        comment: formData.comment,
        resource_column_properties: {
          cross_field_validations: crossFieldValidations,
          unique_columns: uniqueData,
          resource_columns: columns,
          inline_variables: allVariablesList?.resourceColumn || {},
        },
        resource_column_details_tags: formData.resource_tags,
      };
      setResourceColumnObj({
        ...resourceColumnObj,
        ...reqBody2,
      });
      // Transform payload structure to match new API requirements
      const { resource_tags, ...rest } = reqBody1;
      const modifiedReqBody = {
        resource: { ...rest },
        resource_tags,
      };

      updateResource({ currentResourceId, payload: modifiedReqBody })
        .then((response) => {
          // Transform payload structure to match new API requirements
          const { resource_column_details_tags, ...restReqBody2 } = reqBody2;
          const modifiedReqBody2 = {
            resource_column_details: {
              ...restReqBody2,
            },
            resource_column_details_tags,
          };

          updateResourceColumn({
            resourceColumnId,
            payload: modifiedReqBody2,
          })
            .then((res) => {
              if (res) setResourceColumnData(res);
            })
            .catch((err) => {
              showToast("Cannot update resource column", "error");
            });
          if (response) {
            showToast("Resource updated successfully!", "success");
            setResourceData(response);
            persistScoringConfigSilently(
              Number(currentResourceId),
              formData.comment,
            );
          }
        })
        .catch((error) => {
          showToast(`Cannot update resource`, "error");
        });
    } catch (validationErrors: any) {
      const newErrors: { [key: string]: string } = {};
      if (validationErrors.inner) {
        validationErrors.inner.forEach(
          (error: { path: string | number; message: string }) => {
            const fieldName = String(error.path).replace(
              /^resource_definition(\.api_definition)?\./,
              "",
            );
            newErrors[fieldName] = error.message;
          },
        );
      }
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        ...newErrors,
      }));
    } finally {
      setFormData((prev: any) => ({
        ...prev,
        comment: "",
      }));
    }
    setOpenCommentConfirmation(false);
  };
  useEffect(() => {
    setTimeout(() => {
      const findParentElement = formEventRef.current;
      let dataAttr: string;
      if (findParentElement) {
        const findChildElements = findParentElement?.querySelectorAll(
          ".form-control-autocomplete",
        );
        findChildElements.forEach((childElement: any, index: any) => {
          if (!dataAttr) {
            if (childElement.classList.contains("has-error")) {
              dataAttr = childElement
                .closest(".MuiPaper-elevation1")
                ?.getAttribute("data-myattr");
              setExpandedAccordion(dataAttr);
            }
          }
        });
      }
    }, 500);
  }, [isSaveClicked]);

  const handelOnChangeResourceColumn = (e: any, value: any) => {
    if (value?.id !== undefined) {
      setResourceColumnData(value);
      setCurrentResourceColumnId(value?.id);
      setFormData({
        ...formData,
        column_details_id: value?.id,
        resource_column_details_code: value?.code,
      });
    } else {
      setResourceColumnData({});
      setCurrentResourceColumnId(null);
      setFormData({
        ...formData,
        column_details_id: null,
        resource_column_details_code: "",
      });
    }
    const missingKeys = allVariablesList?.resourceColumn
      ? Object.keys(allVariablesList?.resourceColumn).filter((key) => {
          // Check if the key exists in resourceColumn or resource objects
          return allVariablesList?.resource &&
            Object.keys(allVariablesList?.resource).length > 0 &&
            allVariablesList?.baseResource &&
            Object.keys(allVariablesList?.baseResource).length > 0
            ? !Object.keys(allVariablesList?.resource).includes(key) &&
                !Object.keys(allVariablesList?.baseResource).includes(key)
            : [];
        })
      : [];

    const filteredGlobalVariable = Object.fromEntries(
      Object.entries(globalVariables).filter(
        ([key]) => !missingKeys.includes(key),
      ),
    );
    setGlobalVariables(filteredGlobalVariable);
    validateField("resource_column_details_id", value?.id);
  };

  const onAddDerivedColumn = () => {
    prepareAvailableColumnsForQueryBuilder();
    setDerivedModalType("add");
    setOpenDerivedColumnDialog(true);
    setQueryBuilderTempValue("");
  };

  const handelOnChangeLinkedService = (e: any, value: any) => {
    // setSelectLinkedServiceId(value?.id);
    setFormData({
      ...formData,
      linked_service: value,
      resource_definition: {
        ...formData.resource_definition,
        connection_key: null,
        type: value?.sub_type,
        api_definition: {
          method: "get",
          content_type: "application/json",
        },
      },
    });
    setType("");
    validateField("linked_service", value);
  };

  const handleResourceDefinition = (name: any, value: any) => {
    setFormData({
      ...formData,
      resource_definition: {
        ...formData.resource_definition,
        [name]: value,
      },
    });
    validateLinkedServiceField(name, value);
  };

  const handleParquetDefinition = (name: string, value: any) => {
    setFormData({
      ...formData,
      resource_definition: {
        ...formData.resource_definition,
        parquet_export_definition: {
          ...formData.resource_definition?.parquet_export_definition,
          [name]: value,
        },
      },
    });
  };

  const handleApiDefinition = (name: any, value: any) => {
    setFormData({
      ...formData,
      resource_definition: {
        ...formData.resource_definition,
        api_definition: {
          ...formData.resource_definition.api_definition,
          [name]: value,
        },
      },
    });
  };
  const handleChangeTab = (event: any, newValue: any) => {
    if (newValue === "crossFieldValidations") {
      prepareAvailableColumnsForQueryBuilder();
    }
    setActiveTab(newValue);
  };

  const debouncedHandleChangeAccordion = debounce((panel: any) => {
    setExpandedAccordion(panel);
  }, 300);
  const handleChangeAccordion =
    (panel: string) => (event: any, isExpanded: any) => {
      debouncedHandleChangeAccordion(isExpanded ? panel : null);
    };
  const handleAddMoreRow = () => {
    let newRow = { ...editResourceCDMColumns };
    const highestId = fileData.reduce(
      (maxId: any, item: any) => Math.max(maxId, item.id),
      -1,
    );
    newRow.id = highestId + 1;
    const updatedData = [...fileData, newRow];
    setFileData(updatedData);
    const newTotalRows = updatedData.length;
    const maxRowsPerPage = pSize;
    const newPageIndex = Math.floor((newTotalRows - 1) / maxRowsPerPage);
    setTimeout(() => {
      setPage(newPageIndex + 1);
      setTimeout(() => {
        const lastInput = inputRefs.current[updatedData.length - 1];
        if (lastInput) {
          const domNode = ReactDOM.findDOMNode(lastInput);
          if (domNode instanceof HTMLElement) {
            domNode?.focus();
          }
        }
      }, 700);
    }, 300);
  };
  const handleDeleteAllRows = () => {
    if (fileData && fileData.length > 0) {
      setIsDailogOpen(true);
    }
  };
  const handleCancelDeleteAction = () => {
    setIsDailogOpen(false);
  };
  const handleConfirmDeleteAction = () => {
    setIsDailogOpen(false);
    setFileData((prevData: any) => (prevData.length > 0 ? [prevData[0]] : []));
  };
  const onSaveQuery = () => {
    handleResourceDefinition("sql_query", queryBuilderTempValue);
    setAllVariablesList((prev: any) => ({
      ...prev,
      resource: {
        ...prev.resource,
        ...tempGlobalVariables,
      },
    }));

    validateField("sql_query", queryBuilderTempValue);
  };
  const ifMariaDb = formData?.linked_service?.sub_type === "mariadb";

  const handleDetectSensitiveColumns = async () => {
    setIsDetectingColumns(true);
    try {
      const response = await detectSensitiveColumnsService({
        resourceColumnDetailId: currentResourceColumnId,
      });
      const returnedColumns: any[] = Array.isArray(response) ? response : [];

      if (returnedColumns.length === 0) {
        showToast("No column data returned from detection.", "warning");
        return;
      }

      let detectedCount = 0;
      setFileData((prev: any[]) =>
        prev.map((item: any) => {
          const match = returnedColumns.find(
            (rc: any) => rc.column_name === item.column_name,
          );
          if (match?.is_masking) {
            detectedCount++;
            return { ...item, is_masking: true };
          }
          return item;
        }),
      );

      if (detectedCount > 0) {
        showToast(
          `${detectedCount} sensitive column(s) detected and marked for masking.`,
          "success",
        );
      } else {
        showToast("No sensitive columns detected.", "warning");
      }
    } catch (error) {
      showToast(
        "Failed to detect sensitive columns. Please try again.",
        "error",
      );
    } finally {
      setIsDetectingColumns(false);
    }
  };

  const tabContent: any = useMemo(() => {
    return {
      resourceColumns: (
        <Box sx={{ marginTop: "-20px" }}>
          <DataTable
            dataColumns={columns}
            dataRows={fileData}
            checkboxSelection={false}
            className="dataTable no-radius table-focused hide-progress-icon"
            buttonText="Derived Column"
            buttonClass="btn-orange btn-sm btn-dark"
            buttonClick={onAddDerivedColumn}
            buttonIcon={<AddCircleOutlineIcon />}
            loading={isLoading}
            handleEditValidationDialog={handleEditValidationDialog}
            handleDeleteValidation={handleDeleteValidation}
            handleEditReferenceDialog={handleEditReferenceDialog}
            handleDeleteReference={handleDeleteReference}
            handleAddMoreRow={handleAddMoreRow}
            handleDeleteAllRows={handleDeleteAllRows}
            paginationModel={{
              page: page - 1,
              pageSize: pSize,
            }}
            onPaginationModelChange={(params: any) => {
              if (params.pageSize !== pSize || params.page !== page - 1) {
                setPage(params.page + 1);
                setPSize(params.pageSize);
              }
            }}
            isPaginationChangeRequiredOnClientSide={true}
            extraButton={
              canDetectSensitiveColumns ? (
                <Button
                  color="secondary"
                  variant="contained"
                  className="btn-orange btn-sm btn-dark"
                  onClick={handleDetectSensitiveColumns}
                  disabled={isDetectingColumns}
                >
                  {isDetectingColumns
                    ? "Detecting..."
                    : "Detect Sensitive Columns"}
                </Button>
              ) : undefined
            }
          />
        </Box>
      ),
      customValidationSummary: (
        <Box sx={{ marginTop: "-20px" }}>
          <CustomValidationSummary
            customData={resourceColumnObj}
            resourceColumns={fileData}
          />
        </Box>
      ),
      crossFieldValidations: (
        <>
          <CrossFieldValidations
            crossFieldValidations={crossFieldValidations}
            setCrossFieldValidations={setCrossFieldValidations}
            isViewOnly={false}
            errors={errors}
            setErrors={setErrors}
          />
        </>
      ),
      scoringConfig: (
        <Box sx={{ marginTop: "-20px" }}>
          <ValidationScoringConfigForm
            resourceId={Number(currentResourceId)}
            existingConfig={validationScoringConfig}
            onSaveSuccess={() => {}}
            hideCreateButton={true}
            onValuesChange={setScoringConfigValues}
            onValidityChange={setIsScoringConfigValid}
            readOnly={!canEditResource}
          />
        </Box>
      ),
    };
  }, [
    columns,
    fileData,
    onAddDerivedColumn,
    isLoading,
    handleEditValidationDialog,
    handleDeleteValidation,
    resourceColumnObj,
  ]);

  const accordionContent: any = useMemo(() => {
    return {
      resourceData: (
        <>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              type="text"
              fullWidth
              label={
                <span>
                  Domain<span className="required-asterisk">*</span>
                </span>
              }
              variant="outlined"
              className="form-control-autocomplete"
              value={
                domainsData?.find(
                  (option: { id: any }) => option.id === currentDomainId,
                )?.domain_name || ""
              }
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              type="text"
              title="Enter Resource Name"
              name="resource_name"
              // placeholder="Ex: Sample Resource Name"
              onChange={handleFormData}
              onBlur={(e) => validateField(e.target.name, e.target.value)}
              fullWidth
              label={
                <span>
                  Resource Name <span className="required-asterisk">*</span>
                </span>
              }
              value={formData?.resource_name || ""}
              variant="outlined"
              className={`form-control-autocomplete ${
                errors?.resource_name ? "has-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors?.resource_name}
              helperText={errors?.resource_name || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              type="text"
              // placeholder="Ex: Sample Resource Prefix"
              name="resource_prefix"
              onChange={handleFormData}
              fullWidth
              value={formData?.resource_prefix || ""}
              variant="outlined"
              label={
                <span>
                  Resource Prefix <span className="required-asterisk">*</span>
                </span>
              }
              className={`form-control-autocomplete ${
                errors?.resource_prefix ? "has-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors?.resource_prefix}
              helperText={errors?.resource_prefix || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <EditAuthTags
              selectedTagIds={formData?.resource_tags || []}
              onTagsChange={(selectedIds) => {
                setFormData((prev: any) => ({
                  ...prev,
                  resource_tags: selectedIds,
                }));
                validateField("resource_tags", selectedIds);
              }}
              entityName="Resource"
              showToast={showToast}
              errors={errors?.resource_tags}
              validateField={validateField}
              fieldName="resource_tags"
              label="Tag(s)"
              required={true}
              useActiveTagsOnly={true}
              setIsLoading={setIsLoading}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

            <TextField
              type="text"
              title="Enter Resource Type"
              name="resource_type"
              value={formData?.resource_type || ""}
              onChange={handleFormData}
              onBlur={(e) => validateField(e.target.name, e.target.value)}
              fullWidth
              label={
                <span>
                  Resource Type <span className="required-asterisk">*</span>
                </span>
              }
              variant="outlined"
              className={`form-control-autocomplete ${
                errors?.resource_type ? "has-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors?.resource_type}
              helperText={errors?.resource_type || ""}
            />
          </Grid> */}
          <SystemTypeAutocomplete
            allSystemData={allSystemData}
            formData={formData}
            setFormData={setFormData}
            validateField={validateField}
            errors={errors}
          />
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              type="text"
              name="code"
              value={formData?.code || ""}
              fullWidth
              label={
                <span>
                  Code <span className="required-asterisk">*</span>
                </span>
              }
              variant="outlined"
              className={`form-control-autocomplete ${
                errors?.code ? "has-error" : ""
              }`}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors?.code}
              helperText={errors?.code || ""}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Box className="d-flex align-items-end cols-gap-6">
              <Autocomplete
                key={Option.name}
                className={`form-control-autocomplete ${
                  errors?.resource_column_details_id ? "has-error" : ""
                }`}
                fullWidth
                options={resourceColumns}
                getOptionLabel={(option) => option.name || ""}
                value={
                  resourceColumns?.find(
                    (option: any) => option.id === resourceColumnData?.id,
                  ) || null
                }
                renderInput={(params) => (
                  <TextField
                    name="resource_column_details_id"
                    style={{ color: "#000000" }}
                    {...params}
                    label={
                      <span>
                        Resource Columns
                        <span className="required-asterisk">*</span>
                      </span>
                    }
                    placeholder="Select..."
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={!!errors?.resource_column_details_id}
                    helperText={errors?.resource_column_details_id || ""}
                  />
                )}
                renderOption={(props, item) => (
                  <li
                    {...props}
                    key={item.key}
                    style={{ paddingTop: "2px", paddingBottom: "2px" }}
                  >
                    <ListItemText>{item.name}</ListItemText>
                  </li>
                )}
                loadingText="Loading..."
                onChange={(event, value) =>
                  handelOnChangeResourceColumn(event, value)
                }
              />
              {resourceColumnData?.id && isAdmin && (
                <Box
                  className="custom-chip"
                  onClick={() =>
                    window.open(
                      `/resource-columns/${currentDomainId}/view/${resourceColumnData?.id}`,
                      "_blank",
                    )
                  }
                >
                  <Tooltip
                    title={"Click to view resource column"}
                    placement="top"
                  >
                    <IconEyeBase />
                  </Tooltip>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <label className="label-text">
              Aggregation type <span className="required-asterisk">*</span>
            </label>
            <Select
              MenuProps={{
                disableScrollLock: true,
              }}
              title="Aggregation type"
              value={formData.aggregation_type}
              name="aggregation_type"
              style={{ width: "100%", height: 35 }}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  [e.target.name]: e.target.value,
                  aggregation_query: "",
                  resource_definition: {
                    ...formData?.resource_definition,
                    sql_definition: {
                      ...formData?.resource_definition?.sql_definition,
                      sql_query: "",
                    },
                  },
                });
                Object.assign(formData, {
                  ...formData,
                  linked_service: null,
                });
                setBaseResourceColumns([]);
              }}
              className="form-control-autocomplete form-control-autocomplete-1"
            >
              {aggregationType.map((type: string) => (
                <MenuItem key={type} value={type}>
                  <span style={{ textTransform: "capitalize" }}>{type}</span>
                </MenuItem>
              ))}
            </Select>
          </Grid>
          {formData?.aggregation_type === "aggregated" && (
            <AggregatedResource
              errors={errors}
              setErrors={setErrors}
              allVariablesList={allVariablesList}
              setAllVariablesList={setAllVariablesList}
              tempGlobalVariables={tempGlobalVariables}
              setTempGlobalVariables={setTempGlobalVariables}
              isShowRenderVariable={true}
              resourceColumnData={resourceColumnData}
            />
          )}
        </>
      ),
      linkedService: (
        <>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <label className="label-text line-height16">
              <span className="position-relative">
                Connection Type
                <span className="required-asterisk">*</span>
                {formData?.linked_service?.id && (
                  <Tooltip
                    componentsProps={{
                      tooltip: { className: "wide-tooltip w-250" },
                    }}
                    title={
                      formData?.linked_service?.id && (
                        <React.Fragment>
                          <Typography color="inherit">
                            Connection Type Code :{" "}
                            {
                              linkedServices?.find(
                                (item: any) =>
                                  item?.id === formData?.linked_service?.id,
                              )?.code
                            }
                          </Typography>
                        </React.Fragment>
                      )
                    }
                  >
                    <InfoIcon
                      sx={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        right: "-24px",
                        width: "16px",
                      }}
                    />
                  </Tooltip>
                )}
              </span>
            </label>

            <Autocomplete
              fullWidth
              options={linkedServices ?? []}
              getOptionLabel={(option) => option.name || ""}
              value={
                linkedServices?.find(
                  (option: { id: any }) =>
                    option.id === formData?.linked_service?.id,
                ) || null
              }
              renderInput={(params) => (
                <TextField
                  name="linked_service"
                  style={{ color: "#000000" }}
                  {...params}
                  placeholder="Select..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={!!errors?.linked_service}
                  helperText={errors?.linked_service || ""}
                />
              )}
              renderOption={(params, item) => (
                <li
                  {...params}
                  key={item.key}
                  style={{ paddingTop: "2px", paddingBottom: "2px" }}
                >
                  <ListItemText>{item.name}</ListItemText>
                </li>
              )}
              loadingText="Loading..."
              onChange={(event, value) =>
                handelOnChangeLinkedService(event, value)
              }
              className={`form-control-autocomplete ${
                errors?.linked_service ? "has-error" : ""
              }`}
            />
          </Grid>

          {formData?.linked_service?.type === "file" && (
            <>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Autocomplete
                  fullWidth
                  options={connectionKeysData || []}
                  getOptionLabel={(connectionData) => connectionData.name}
                  onChange={async (event, value) => {
                    const connectionKeyId = value?.id;
                    // Check for system_id mismatch before setting the value
                    const hasMismatch = await validateSystemIdMismatch(
                      connectionKeyId,
                      "file",
                    );
                    if (!hasMismatch) {
                      handleResourceDefinition(
                        "connection_key",
                        connectionKeyId,
                      );
                    }
                  }}
                  value={
                    connectionKeysData?.find(
                      (option: { id: any }) =>
                        option.id ===
                        formData?.resource_definition?.connection_key,
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      name="connection_key"
                      style={{ color: "#000000" }}
                      {...params}
                      label={
                        <span>
                          Connection Key
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      placeholder="Select..."
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.connection_key}
                      helperText={errors?.connection_key}
                    />
                  )}
                  loadingText="Loading..."
                  className={`form-control-autocomplete ${
                    errors?.connection_key ? "has-error" : ""
                  }`}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text">
                  <span className="position-relative">
                    File Processing Attribute{" "}
                    <span className="required-asterisk">*</span>
                    {formData?.file_processing_id && (
                      <Tooltip
                        componentsProps={{
                          tooltip: { className: "wide-tooltip w-380" },
                        }}
                        title={
                          <pre
                            style={{
                              whiteSpace: "pre-wrap",
                              margin: 0,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            <React.Fragment>
                              <Typography color="inherit">
                                File Processing Detail
                              </Typography>
                              <Typography>
                                {formattedJson(
                                  JSON.stringify(
                                    fileProcessingData?.find(
                                      (file: any) =>
                                        file?.id ===
                                        formData?.file_processing_id,
                                    ),
                                  ),
                                )}
                              </Typography>
                            </React.Fragment>
                          </pre>
                        }
                      >
                        <InfoIcon
                          sx={{
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            right: "-24px",
                            width: "16px",
                          }}
                        />
                      </Tooltip>
                    )}
                  </span>
                </label>
                <Autocomplete
                  fullWidth
                  options={fileProcessingData}
                  getOptionLabel={(option) => option.resource_type || ""}
                  renderInput={(params) => (
                    <TextField
                      name="file_processing_id"
                      style={{ color: "#000000" }}
                      {...params}
                      // label="File Processing Attributes"
                      placeholder="Select..."
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.file_processing_id}
                      helperText={errors?.file_processing_id || ""}
                    />
                  )}
                  loadingText="Loading..."
                  onChange={(event, value) => {
                    setFormData({
                      ...formData,
                      file_processing_id: value?.id,
                      file_processing_code: value?.code,
                    });
                    validateLinkedServiceField("file_processing_id", value?.id);
                  }}
                  value={
                    fileProcessingData?.find(
                      (option: { id: any }) =>
                        option.id === formData?.file_processing_id,
                    ) || null
                  }
                  className={`form-control-autocomplete ${
                    errors?.file_processing_id ? "has-error" : ""
                  }`}
                />
              </Grid>

              {formData?.linked_service?.sub_type === "sftp" ? (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <TextField
                    type="text"
                    title="remote_directory"
                    name="remote_directory"
                    fullWidth
                    label={
                      <span>
                        Remote Directory
                        <span className="required-asterisk">*</span>
                      </span>
                    }
                    variant="outlined"
                    className={`form-control-autocomplete ${
                      errors?.remote_directory ? "has-error" : ""
                    }`}
                    onChange={(e: any) =>
                      handleResourceDefinition(e.target.name, e.target.value)
                    }
                    // placeholder="Ex: Sample Remote Directory"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      formData?.resource_definition?.remote_directory || ""
                    }
                    error={!!errors?.remote_directory}
                    helperText={errors?.remote_directory || ""}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <TextField
                    type="text"
                    title="resource_path"
                    name="resource_path"
                    fullWidth
                    label={
                      <span>
                        Resource Path
                        <span className="required-asterisk">*</span>
                      </span>
                    }
                    variant="outlined"
                    className={`form-control-autocomplete ${
                      errors?.resource_path ? "has-error" : ""
                    }`}
                    onChange={(e: any) =>
                      handleResourceDefinition(e.target.name, e.target.value)
                    }
                    // placeholder="Ex: Sample Resource Path"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={formData?.resource_definition?.resource_path || ""}
                    error={!!errors?.resource_path}
                    helperText={errors?.resource_path || ""}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <TextField
                  type="text"
                  title="column_delimiter"
                  name="column_delimiter"
                  fullWidth
                  label={<span>Column Delimiter</span>}
                  variant="outlined"
                  className={`form-control-autocomplete`}
                  onChange={(e: any) => {
                    setFormData({
                      ...formData,
                      resource_definition: {
                        ...formData.resource_definition,
                        [e.target.name]: e.target.value,
                      },
                    });
                  }}
                  // placeholder="Ex: Sample Column Delimiter"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData?.resource_definition?.column_delimiter || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <TextField
                  type="text"
                  title="file_name"
                  name="file_name"
                  fullWidth
                  label={<span>File Name</span>}
                  variant="outlined"
                  className={`form-control-autocomplete`}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { name, value } = e.target;
                    const isExcelFile = /\.(xlsx|xls)$/i.test(value);

                    setFormData(
                      (prev: {
                        resource_definition: { excel_sheet_name: string };
                      }) => {
                        const prevSheetName =
                          prev.resource_definition?.excel_sheet_name || "";

                        return {
                          ...prev,
                          resource_definition: {
                            ...prev.resource_definition,
                            [name]: value,
                            excel_sheet_name: isExcelFile ? "" : prevSheetName,
                          },
                        };
                      },
                    );
                  }}
                  // placeholder="Ex: Sample File Name"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData?.resource_definition?.file_name || ""}
                />
              </Grid>
              {(formData?.linked_service?.sub_type === "local" ||
                formData?.linked_service?.sub_type === "blob" ||
                formData?.linked_service?.sub_type === "sftp") &&
                formData?.resource_definition?.file_name &&
                /\.(xlsx|xls)$/i.test(
                  formData?.resource_definition?.file_name,
                ) && (
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="excel_sheet_name"
                      name="excel_sheet_name"
                      fullWidth
                      label={<span>Excel Sheet Name</span>}
                      variant="outlined"
                      className={`form-control-autocomplete`}
                      onChange={(e: any) => {
                        setFormData({
                          ...formData,
                          resource_definition: {
                            ...formData.resource_definition,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        formData?.resource_definition?.excel_sheet_name || ""
                      }
                    />
                  </Grid>
                )}
            </>
          )}
          {(formData?.linked_service?.type === "sql" ||
            formData?.linked_service?.type === "postgres_sql") && (
            <>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Autocomplete
                  fullWidth
                  options={
                    connectionKeysData.filter(
                      (item: any) => item.system_id === formData?.system_id,
                    ) ?? []
                  }
                  getOptionLabel={(connectionData) => connectionData.name}
                  onChange={async (event, value) => {
                    const connectionKeyId = value?.id;
                    // Check for system_id mismatch before setting the value
                    const hasMismatch = await validateSystemIdMismatch(
                      connectionKeyId,
                      "sql",
                    );
                    if (!hasMismatch) {
                      handleResourceDefinition(
                        "connection_key",
                        connectionKeyId,
                      );
                    }
                  }}
                  value={
                    connectionKeysData?.find(
                      (option: { id: any }) =>
                        option.id ===
                        formData?.resource_definition?.connection_key,
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      name="connection_key"
                      style={{ color: "#000000" }}
                      {...params}
                      label={
                        <span>
                          Connection Key
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      placeholder="Select..."
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.connection_key}
                      helperText={errors?.connection_key || ""}
                    />
                  )}
                  loadingText="Loading..."
                  className={`form-control-autocomplete ${
                    errors?.connection_key ? "has-error" : ""
                  }`}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                xl={4}
                style={{ display: "none" }}
              >
                <TextField
                  type="text"
                  title="Connection String"
                  name="connectionString"
                  fullWidth
                  label={
                    <span>
                      Connection String
                      <span className="required-asterisk">*</span>
                    </span>
                  }
                  variant="outlined"
                  className="form-control-autocomplete"
                  value={formData?.resource_definition?.connection_string}
                  InputLabelProps={{
                    shrink: formData?.resource_definition?.connection_string
                      ? true
                      : false,
                  }}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text">
                  SQL definition <span className="required-asterisk">*</span>
                </label>
                <TextField
                  type="text"
                  value={formData?.resource_definition?.sql_query || ""}
                  onClick={() => {
                    setShowQryModal(true);
                    if (formData?.resource_definition?.sql_query) {
                      setQueryBuilderTempValue(
                        formData?.resource_definition?.sql_query,
                      );
                    }
                    const baseColumns =
                      resourceColumnDataObj?.resource_column_properties?.resource_columns
                        ?.map((columnItem: any) => {
                          if (columnItem?.is_active) {
                            return columnItem.column_name;
                          }
                        })
                        .filter((filterItem: any) => filterItem);

                    const columnsToUse = baseColumns ?? [];

                    // Merge with additional resource columns if they exist
                    if (
                      formData?.additional_resource_data &&
                      formData.additional_resource_data.length > 0 &&
                      allResourcesAdditionalData &&
                      allResourcesAdditionalData.length > 0 &&
                      resourceColumnsFromContext &&
                      resourceColumnsFromContext.length > 0
                    ) {
                      // Build resource column data for additional resources
                      const resourceColumnIds =
                        formData.additional_resource_data.map(
                          (res: any) => res.resource_id,
                        );
                      const updatedColumnsData = resourceColumnIds.map(
                        (res_id: any) => {
                          const resource_column_ids =
                            allResourcesAdditionalData?.find(
                              (res1: { id: number }) => res1.id === res_id,
                            )?.additional_properties
                              ?.resource_column_details_id;

                          const resource_column =
                            resourceColumnsFromContext?.find(
                              (res1: { id: number }) =>
                                res1.id === resource_column_ids,
                            )?.resource_column_properties?.resource_columns;
                          return {
                            resource_id: res_id,
                            resource_columns: resource_column,
                          };
                        },
                      );

                      // Build additional resource column info
                      const additionalResourceColumnInfo =
                        buildAdditionalResourceColumnInfo(
                          formData.additional_resource_data,
                          allResourcesAdditionalData,
                          updatedColumnsData,
                        );

                      // Use new function that returns structured data with metadata
                      const structuredColumns =
                        mergeResourceColumnsWithMetadata(
                          columnsToUse,
                          additionalResourceColumnInfo,
                          allResourcesAdditionalData,
                        );
                      setAvailColumns(structuredColumns);
                    } else {
                      // No additional resources, use base columns only
                      setAvailColumns(columnsToUse);
                    }
                    setAvailColumnsWithResourceDetail(null);
                  }}
                  className={`form-control-autocomplete ${
                    errors?.sql_query ? "has-error" : ""
                  }`}
                  InputProps={{
                    readOnly: true,
                  }}
                  error={!!errors?.sql_query}
                  helperText={errors?.sql_query}
                />
                {/* <Box className="ace-editor">
                  <AceEditor
                    mode="sql"
                    theme="github"
                    onChange={(value) =>
                      handleResourceDefinition("sql_query", value)
                    }
                    value={formData?.resource_definition?.sql_query || ""}
                    width="100%"
                    height="100px"
                    editorProps={{ $blockScrolling: true }}
                    ref={editorRef}
                    showGutter
                    placeholder={` ${
                      formData?.resource_definition?.sql_definition?.sql_query
                        ? ""
                        : "Write your query here..."
                    } `}
                    aria-label="queryEditor"
                    name="editor"
                    fontSize={15}
                    minLines={4}
                    maxLines={4}
                    showPrintMargin={false}
                    className={`sql-editor ${
                      errors?.expression ? "has-error" : ""
                    }`}
                  />
                </Box>
                {errors?.sql_query && (
                  <div className="error-text">{errors?.sql_query}</div>
                )} */}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text line-height20">&nbsp;</label>
                <label className="base-resource-checkbox m-0">
                  <Checkbox
                    checked={
                      formData.resource_definition?.use_multi_thread_reader ||
                      false
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setFormData({
                        ...formData,
                        resource_definition: {
                          ...formData.resource_definition,
                          use_multi_thread_reader: event.target.checked,
                          column_name_to_partition_on_sql_query: event.target
                            .checked
                            ? formData.resource_definition
                                ?.column_name_to_partition_on_sql_query || ""
                            : "",
                        },
                      });
                    }}
                    sx={{
                      "&.Mui-checked": {
                        color: "#FFA500",
                      },
                    }}
                  />
                  <span>Use Multi Thread Reader</span>
                </label>
              </Grid>

              {formData.resource_definition?.use_multi_thread_reader && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <TextField
                    type="text"
                    title="column_name_to_partition_on_sql_query"
                    name="column_name_to_partition_on_sql_query"
                    fullWidth
                    label={
                      <span>
                        Column Name to Partition On
                        <span className="required-asterisk">*</span>
                      </span>
                    }
                    variant="outlined"
                    className={`form-control-autocomplete ${
                      errors?.column_name_to_partition_on_sql_query
                        ? "has-error"
                        : ""
                    }`}
                    value={
                      formData.resource_definition
                        ?.column_name_to_partition_on_sql_query || ""
                    }
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        resource_definition: {
                          ...formData.resource_definition,
                          column_name_to_partition_on_sql_query: e.target.value,
                        },
                      });
                    }}
                    error={!!errors?.column_name_to_partition_on_sql_query}
                    helperText={errors?.column_name_to_partition_on_sql_query}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              )}

              {/* Enable Parquet Export checkbox */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text line-height20">&nbsp;</label>
                <label className="base-resource-checkbox m-0">
                  <Checkbox
                    checked={
                      !!formData?.resource_definition?.use_parquet_export
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      if (event.target.checked) {
                        const flatColumns = Array.isArray(availColumns)
                          ? availColumns
                          : (availColumns as any)?.flatColumns || [];
                        if (flatColumns.length === 0) {
                          showToast(
                            "A Column Definition must be selected or created before enabling Parquet Export. Please configure the resource columns first.",
                            "warning",
                          );
                          return;
                        }
                      }
                      handleResourceDefinition(
                        "use_parquet_export",
                        event.target.checked,
                      );
                    }}
                    sx={{
                      "&.Mui-checked": {
                        color: "#FFA500",
                      },
                    }}
                  />
                  <span>Enable Parquet Export</span>
                </label>
              </Grid>

              {/* Parquet Export Configuration accordion */}
              {formData?.resource_definition?.use_parquet_export && (
                <Grid item xs={12}>
                  <Accordion className="heading-bold box-shadow mb-6 color-palette color-palette-1">
                    <AccordionSummary
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                      expandIcon={<ExpandMoreIcon />}
                    >
                      Parquet Export Configuration
                    </AccordionSummary>
                    <AccordionDetails sx={{ paddingTop: "16px" }}>
                      <Grid container rowSpacing={1.5} columnSpacing={2.5}>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text">
                            Partition Column{" "}
                            <span className="required-asterisk">*</span>
                          </label>
                          <Autocomplete
                            fullWidth
                            options={
                              Array.isArray(availColumns)
                                ? availColumns
                                : (availColumns as any)?.flatColumns || []
                            }
                            value={
                              formData?.resource_definition
                                ?.parquet_export_definition?.partition_column ||
                              null
                            }
                            onChange={(_, value) =>
                              handleParquetDefinition(
                                "partition_column",
                                value || "",
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select column..."
                                className={`form-control-autocomplete ${
                                  errors?.partition_column ? "has-error" : ""
                                }`}
                                error={!!errors?.partition_column}
                                helperText={errors?.partition_column || ""}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text">
                            Partition Strategy
                          </label>
                          <Autocomplete
                            fullWidth
                            options={["hash", "range", "modulo"]}
                            value={
                              formData?.resource_definition
                                ?.parquet_export_definition
                                ?.partition_strategy || null
                            }
                            onChange={(_, value) =>
                              handleParquetDefinition(
                                "partition_strategy",
                                value || null,
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select..."
                                className="form-control-autocomplete"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text">
                            Number of Partitions
                          </label>
                          <TextField
                            fullWidth
                            type="number"
                            name="number_of_partitions"
                            variant="outlined"
                            className="form-control-autocomplete"
                            value={
                              formData?.resource_definition
                                ?.parquet_export_definition
                                ?.number_of_partitions ?? 1
                            }
                            onChange={(e) =>
                              handleParquetDefinition(
                                "number_of_partitions",
                                parseInt(e.target.value) || 1,
                              )
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 1 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text">Max Workers</label>
                          <TextField
                            fullWidth
                            type="number"
                            name="max_workers"
                            variant="outlined"
                            className="form-control-autocomplete"
                            value={
                              formData?.resource_definition
                                ?.parquet_export_definition?.max_workers ?? 4
                            }
                            onChange={(e) =>
                              handleParquetDefinition(
                                "max_workers",
                                parseInt(e.target.value) || 4,
                              )
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 1 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text">Chunk Size</label>
                          <TextField
                            fullWidth
                            type="number"
                            name="chunk_size"
                            variant="outlined"
                            className="form-control-autocomplete"
                            value={
                              formData?.resource_definition
                                ?.parquet_export_definition?.chunk_size ?? 50000
                            }
                            onChange={(e) =>
                              handleParquetDefinition(
                                "chunk_size",
                                parseInt(e.target.value) || 50000,
                              )
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 1 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text line-height20">
                            &nbsp;
                          </label>
                          <label className="base-resource-checkbox m-0">
                            <Checkbox
                              checked={
                                !!formData?.resource_definition
                                  ?.parquet_export_definition
                                  ?.enable_compression
                              }
                              onChange={(e) =>
                                handleParquetDefinition(
                                  "enable_compression",
                                  e.target.checked,
                                )
                              }
                              sx={{
                                "&.Mui-checked": {
                                  color: "#FFA500",
                                },
                              }}
                            />
                            <span>Enable Compression</span>
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="label-text line-height10">
                            &nbsp;
                          </label>
                          <label className="base-resource-checkbox m-0">
                            <Checkbox
                              checked={
                                !!formData?.resource_definition
                                  ?.parquet_export_definition
                                  ?.merge_output_files
                              }
                              onChange={(e) =>
                                handleParquetDefinition(
                                  "merge_output_files",
                                  e.target.checked,
                                )
                              }
                              sx={{
                                "&.Mui-checked": {
                                  color: "#FFA500",
                                },
                              }}
                            />
                            <span>Merge Output Files</span>
                          </label>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              )}
            </>
          )}

          {formData?.linked_service?.sub_type === "blob" && (
            <>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <TextField
                  type="text"
                  title="container_name"
                  name="container_name"
                  fullWidth
                  label={
                    <span>
                      Container Name<span className="required-asterisk">*</span>
                    </span>
                  }
                  variant="outlined"
                  className={`form-control-autocomplete ${
                    errors?.container_name ? "has-error" : ""
                  }`}
                  onChange={(e: any) =>
                    handleResourceDefinition(e.target.name, e.target.value)
                  }
                  // placeholder="Ex: Sample Container Name"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData?.resource_definition?.container_name || ""}
                  error={!!errors?.container_name}
                  helperText={errors?.container_name || ""}
                />
              </Grid>
            </>
          )}
          {formData?.linked_service?.type === "api" && (
            <>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <Autocomplete
                  fullWidth
                  options={connectionKeysData || []}
                  getOptionLabel={(connectionData) => connectionData.name}
                  onChange={async (event, value) => {
                    const connectionKeyId = value?.id;
                    // Check for system_id mismatch before setting the value
                    const hasMismatch = await validateSystemIdMismatch(
                      connectionKeyId,
                      "api",
                    );
                    if (!hasMismatch) {
                      handleApiDefinition("connection_key", connectionKeyId);
                      setType(value?.type);
                      validateApiDefinitionField(
                        "connection_key",
                        connectionKeyId,
                      );
                    }
                  }}
                  value={
                    connectionKeysData?.find(
                      (option: { id: any }) =>
                        option.id ===
                        formData?.resource_definition?.api_definition
                          ?.connection_key,
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      name="connection_key"
                      style={{ color: "#000000" }}
                      {...params}
                      label={
                        <span>
                          Connection Key
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      placeholder="Select..."
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.connection_key}
                      helperText={errors?.connection_key}
                    />
                  )}
                  loadingText="Loading..."
                  className={`form-control-autocomplete ${
                    errors?.connection_key ? "has-error" : ""
                  }`}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text">Method</label>
                <Select
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                  defaultValue="get"
                  title="method"
                  value={formData?.resource_definition?.api_definition?.method}
                  name="method"
                  style={{ width: "100%", height: 35 }}
                  onChange={(e) => {
                    handleApiDefinition(e.target.name, e.target.value);
                  }}
                  className={`form-control-autocomplete form-control-autocomplete-1`}
                >
                  {methodType.map((type: string) => (
                    <MenuItem key={type} value={type}>
                      <span style={{ textTransform: "capitalize" }}>
                        {type}
                      </span>
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <label className="label-text">Content Type</label>
                <Select
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                  defaultValue="application/json"
                  title="content_type"
                  value={
                    formData?.resource_definition?.api_definition?.content_type
                  }
                  name="content_type"
                  style={{ width: "100%", height: 35 }}
                  onChange={(e) => {
                    handleApiDefinition(e.target.name, e.target.value);
                  }}
                  className={`form-control-autocomplete form-control-autocomplete-1`}
                >
                  {contentType.map((type: string) => (
                    <MenuItem key={type} value={type}>
                      <span style={{ textTransform: "capitalize" }}>
                        {type}
                      </span>
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              {type === "basic_auth_api" && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="user_name"
                      name="user_name"
                      fullWidth
                      label={
                        <span>
                          Username <span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.user_name ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.user_name || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.user_name}
                      helperText={errors?.user_name || ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="password"
                      title="password"
                      name="password"
                      fullWidth
                      label={
                        <span>
                          Password<span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.password ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.password || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.password}
                      helperText={errors?.password || ""}
                    />
                  </Grid>
                </>
              )}
              {type === "token_auth_api" && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="bearer_token"
                      name="bearer_token"
                      fullWidth
                      label={
                        <span>
                          Bearer Token{" "}
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.bearer_token ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.bearer_token || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.bearer_token}
                      helperText={errors?.bearer_token || ""}
                    />
                  </Grid>
                </>
              )}
              {type === "key_auth_api" && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="api_key"
                      name="api_key"
                      fullWidth
                      label={
                        <span>
                          Api Key <span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.api_key ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.api_key || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.api_key}
                      helperText={errors?.api_key || ""}
                    />
                  </Grid>
                </>
              )}
              {type === "oauth_api" && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="oauth_client_id"
                      name="oauth_client_id"
                      fullWidth
                      label={
                        <span>
                          Oauth Client Id{" "}
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.oauth_client_id ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.oauth_client_id || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.oauth_client_id}
                      helperText={errors?.oauth_client_id || ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="oauth_client_secret"
                      name="oauth_client_secret"
                      fullWidth
                      label={
                        <span>
                          Oauth Client Secret
                          <span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.oauth_client_secret ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.oauth_client_secret || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.oauth_client_secret}
                      helperText={errors?.oauth_client_secret || ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <TextField
                      type="text"
                      title="oauth_url"
                      name="oauth_url"
                      fullWidth
                      label={
                        <span>
                          Oauth Url<span className="required-asterisk">*</span>
                        </span>
                      }
                      variant="outlined"
                      className={`form-control-autocomplete ${
                        errors?.oauth_url ? "has-error" : ""
                      }`}
                      value={
                        formData?.resource_definition?.api_definition
                          ?.oauth_url || ""
                      }
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                        validateApiDefinitionField(
                          e.target.name,
                          e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors?.oauth_url}
                      helperText={errors?.oauth_url || ""}
                    />
                  </Grid>
                </>
              )}
            </>
          )}
          {formData?.linked_service?.type === "api" && (
            <>
              <Grid container item rowSpacing={2.5} columnSpacing={4}>
                {formData?.resource_definition?.api_definition?.method !==
                  "get" && (
                  <Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
                    <label className="label-text">Request Body</label>
                    <TextareaAutosize
                      title="Request Body"
                      name="body"
                      minRows={3}
                      maxRows={6}
                      className={`form-control-1`}
                      onChange={(e) => {
                        handleApiDefinition(e.target.name, e.target.value);
                      }}
                      value={
                        formData?.resource_definition?.api_definition?.body
                      }
                    />
                  </Grid>
                )}
                <Grid item xs={6}>
                  <AddMultiGrid
                    gridValue={queryParams}
                    setGridValue={setQueryParams}
                    isViewOnly={false}
                    heading={"Query Params"}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AddMultiGrid
                    gridValue={urlParams}
                    setGridValue={setUrlParams}
                    isViewOnly={false}
                    heading={"Url Params"}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </>
      ),
      additionalData: (
        <AdditionalResource
          resourceColumnId={currentResourceColumnId}
          resourceColumns={resourceColumns}
          setAllVariablesList={setAllVariablesList}
          allVariablesList={allVariablesList}
          tempGlobalVariables={tempGlobalVariables}
        />
      ),
      filterRules: (
        <>
          <FilterRules
            formData={formData}
            setFormData={setFormData}
            resourceColumnData={resourceColumnData}
            errors={errors}
            checkFilterRuleValidation={checkFilterRuleValidation}
            setAllVariablesList={setAllVariablesList}
            fileData={fileData}
            isFromExecution={false}
          />
        </>
      ),
    };
  }, [errors, formData, errors, domainsData, handleFormData, resourceColumns]);

  const accordionHeaderContent = (
    <Box sx={{ marginTop: 2 }} className="accordion-panel">
      {ACCORDION_HEADER &&
        Object.keys(ACCORDION_HEADER).map((item: any, idx: any) => {
          if (
            item === "linkedService" &&
            formData?.aggregation_type === "aggregated"
          ) {
            return null;
          }
          return (
            <Accordion
              className={`heading-bold box-shadow mb-6
                ${
                  item === "resourceData"
                    ? "color-palette color-palette-2"
                    : item === "linkedService"
                      ? "color-palette color-palette-2-d"
                      : item === "additionalData"
                        ? "color-palette color-palette-2-a"
                        : item === "filterRules"
                          ? "color-palette color-palette-1"
                          : "color-palette color-palette-1"
                }`}
              expanded={expandedAccordion === item}
              onChange={handleChangeAccordion(item)}
              data-myattr={`${item}`}
              key={item}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={<ExpandMoreIcon />}
              >
                {ACCORDION_HEADER[item]}
              </AccordionSummary>
              <AccordionDetails sx={{ paddingTop: "16px" }}>
                <Grid container rowSpacing={1.5} columnSpacing={2.5}>
                  {accordionContent[item]}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}

      {globalVariables && Object.keys(globalVariables).length > 0 && (
        <CustomAccordion
          expandId="panel2d-header-support-documents"
          title="Resource Variables"
          isEnabled={true}
          topMargin={6}
          className="color-palette color-palette-1"
        >
          <ViewVariables
            isViewOnly={true}
            error={errors}
            setErrors={setErrors}
          />
        </CustomAccordion>
      )}
    </Box>
  );

  const handleCommentChange = (e: any) => {
    setFormData((prev: any) => ({
      ...prev,
      comment: e.target.value,
    }));
  };

  const handleSaveComment = async (e: any) => {
    onSaveResource(e);
  };
  const handleCancelComment = () => {
    setOpenCommentConfirmation(false);
    setFormData((prev: any) => ({
      ...prev,
      comment: "",
    }));
  };

  return (
    <>
      {Object.values(loadingStates).some(Boolean) && <Loader isLoading />}
      <Box>
        <form autoComplete="off" ref={formEventRef}>
          <Box className="dashboard-title-group flex-end">
            <div className="right-column column-gap-12">
              {canValidateResource && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    navigate(
                      `/resource/${currentDomainId}/validate-resource/${currentResourceId}`,
                    )
                  }
                  className="btn-orange btn-nostyle min-width-auto btn-blue"
                >
                  Validate
                </Button>
              )}
              <ViewJsonSplitButton
                onViewJson={() => setIsPayloadDialogOpen(true)}
                onCopyJson={handleCopyPayload}
                className="min-width-auto"
              />
              <Button
                type="button"
                onClick={() => handleValidations()}
                variant="contained"
                color="secondary"
                fullWidth
                className="btn-orange min-width-auto"
                title="Save Resource"
                disabled={!hasChanges || !canSaveScoringConfig}
              >
                <SaveOutlinedIcon /> &nbsp; Save
              </Button>
            </div>
          </Box>
          {/* accordionHeaderContent */}
          {accordionHeaderContent}
          <Tabs
            sx={{
              mt: 1,
            }}
            value={activeTab}
            onChange={handleChangeTab}
            className="mui-tabs alternative-1"
            variant="scrollable"
          >
            <Tab label="Resource Columns" value="resourceColumns" />
            <Tab
              label="Custom Validation Summary"
              value="customValidationSummary"
            />
            <Tab label="Adhoc Query" value="crossFieldValidations" />
            <Tab label="Scoring Config" value="scoringConfig" />
          </Tabs>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Box>{tabContent[activeTab]}</Box>
          </Grid>

          <Grid
            mx={{
              marginTop: "16px",
              justifyContent: "flex-end",
              display: "flex",
              gap: "8px",
            }}
          >
            <ViewJsonSplitButton
              onViewJson={() => setIsPayloadDialogOpen(true)}
              onCopyJson={handleCopyPayload}
            />
            <Button
              variant="contained"
              color="secondary"
              className="btn-orange"
              type="button"
              onClick={() => handleValidations()}
              disabled={!hasChanges || !canSaveScoringConfig}
            >
              <SaveOutlinedIcon /> &nbsp; Save
            </Button>
          </Grid>
          <ValidationDialog setAllVariablesList={setAllVariablesList} />

          <DerivedColumnDialog setAllVariablesList={setAllVariablesList} />
          <ReferenceDialog setAllVariablesList={setAllVariablesList} />
        </form>
        <ConfirmDailog
          isDailogOpen={isDailogOpen}
          handleCancelAction={handleCancelDeleteAction}
          handleConfirmAction={handleConfirmDeleteAction}
          dailogTitle={"Confirm Delete"}
          dailogDescription={
            "This action will delete all rows, still want to continue?"
          }
        />
        <SqlQueryDialog
          showQryModal={showQryModal}
          setShowQryModal={setShowQryModal}
          onSaveQuery={onSaveQuery}
        />
        <CommentBeforeUpdateDialog
          title={"Confirm updating Resource"}
          dialogContent={
            <div>
              <p className="m-0 mb-2">
                Add a note before updating the Resource
              </p>
              <textarea
                value={formData?.comment}
                className={`form-control-1 max-60`}
                onChange={(e) => handleCommentChange(e)}
              />
            </div>
          }
          openConfirmation={openCommentConfirmation}
          handleSaveComment={(e) => handleSaveComment(e)}
          handleCancel={handleCancelComment}
        />

        {/* System ID Mismatch Warning Modal */}
        <ConfirmDailog
          isDailogOpen={showSystemIdMismatchModal}
          handleCancelAction={handleSystemIdMismatchCancel}
          handleConfirmAction={handleSystemIdMismatchProceed}
          dailogTitle="System ID Mismatch Warning"
          whiteSpace={"pre-line"}
          dailogDescription={
            systemIdMismatchData
              ? `Warning: This resource has a connection key "${systemIdMismatchData.connectionKeyName}" with a different System (${systemIdMismatchData.connectionKeySystemId}) than the resource's System (${systemIdMismatchData.resourceSystemId}).
              Choose an action:
              •"Continue" will update the resource's System to ${systemIdMismatchData.connectionKeySystemId} to match the connection key, or
              •"Cancel" will clear the connection key field.`
              : "System ID mismatch detected."
          }
        />
        <ViewPayloadDialog
          openDialog={isPayloadDialogOpen}
          dialogTitle="Edit Resource & Resource Column JSON"
          payload={buildPayload()}
          handleDialogClose={() => {
            setIsPayloadDialogOpen(false);
            setValidationResponse(null);
          }}
          onValidate={handleValidatePayload}
          isValidating={isValidating}
          validationResponse={validationResponse}
        />
      </Box>
    </>
  );
};

export default EditResource;
